import * as React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import { useImmer } from 'use-immer';
import { usePopper } from 'react-popper';
import ReactDOM from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';
import { useCombobox } from 'downshift';
import { toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';
import TextareaAutosize from 'react-textarea-autosize';
import InfiniteScroll from 'react-infinite-scroller';
import { useInfiniteLoader, Masonry } from 'masonic';

function _mergeNamespaces(n, m) {
  m.forEach(function (e) {
    e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function (k) {
      if (k !== 'default' && !(k in n)) {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  });
  return n;
}

var styles$r = {"path":"storyliner-lvdysx4w","circle":"storyliner-QGyBF-Jk"};

// svgs/LogoSymbol

var LogoSymbol = function LogoSymbol() {
  return React.createElement("svg", {
    height: "100%",
    version: "1.1",
    viewBox: "0 0 631 631",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,-10914.3,-6836.81)"
  }, React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,10244.3,5100.94)"
  }, React.createElement("g", {
    transform: "matrix(0.134768,0,0,0.134768,-1261.92,-476.183)"
  }, React.createElement("circle", {
    className: styles$r['circle'],
    cx: "11118.4",
    cy: "7186.09",
    r: "556.513"
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,10244.3,5100.94)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,235.12,554.72)"
  }, React.createElement("path", {
    className: styles$r['path'],
    d: "M0,-35.739L-1.23,-37.8L-8.63,-31.219C-10.27,-29.849 -12.19,-27.319 -14.38,-23.62C-16.58,-19.92 -18.29,-16.16 -19.52,-12.319C-20.75,-8.489 -21.03,-5.13 -20.34,-2.25C-19.66,0.62 -17.26,2.061 -13.15,2.061C-10.68,2.061 -8.15,1.101 -5.55,-0.809C-2.95,-2.729 -0.82,-5.399 0.82,-8.83C2.47,-12.26 3.35,-16.29 3.49,-20.95C3.63,-25.609 2.47,-30.54 0,-35.739",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,10244.3,5100.94)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,217.86,455.95)"
  }, React.createElement("path", {
    className: styles$r['path'],
    d: "M0,63.85L12.74,53.991C10.55,49.88 8.22,45.43 5.75,40.63C3.29,35.84 1.16,30.97 -0.62,26.04C-2.4,21.11 -3.56,16.11 -4.11,11.04C-4.66,5.98 -4.25,1.11 -2.88,-3.55C-1.23,-9.02 1.44,-14.16 5.14,-18.96C8.84,-23.75 12.95,-27.86 17.47,-31.29C21.29,-34.18 25.1,-36.62 28.92,-38.64C25.56,-39.1 22.12,-39.34 18.63,-39.34C-23.16,-39.34 -57.04,-5.46 -57.04,36.33C-57.04,53.26 -51.48,68.9 -42.07,81.51C-38.83,85.871 -35.12,89.86 -31.03,93.43C-26.7,97.201 -21.93,100.48 -16.82,103.19C-19.63,98.15 -19.97,92.77 -17.87,87.07C-15,79.26 -9.04,71.52 0,63.85",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,10244.3,5100.94)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,241.7,446.31)"
  }, React.createElement("path", {
    className: styles$r['path'],
    d: "M0,31.98C0.54,34.45 1.29,37.33 2.26,40.61C3.21,43.9 4.38,47.19 5.75,50.48C13.69,44.45 21.91,38.15 30.41,31.57C38.89,25 46.7,18.97 53.83,13.49C55.48,12.21 57.8,10.48 60.51,8.47C58.28,4.56 55.71,0.87 52.84,-2.56C47.62,-8.81 41.4,-14.2 34.44,-18.5C26.83,-16.13 20.29,-13.01 14.79,-9.11C9.04,-5.27 4.38,-0 0.82,6.71C-2.75,13.43 -3.02,21.85 0,31.98",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,10244.3,5100.94)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,306.27,567.93)"
  }, React.createElement("path", {
    className: styles$r['path'],
    d: "M0,-104.96C-2.65,-103.46 -4.8,-102.16 -6.22,-101.14C-13.89,-95.66 -22.18,-89.7 -31.08,-83.27C-39.99,-76.83 -48.41,-70.46 -56.35,-64.16C-54.44,-58.67 -52.73,-54.09 -51.22,-50.39C-49.72,-46.689 -48.55,-43.13 -47.72,-39.71C-46.9,-36.29 -46.7,-32.79 -47.11,-29.23C-47.52,-25.67 -48.69,-21.42 -50.6,-16.489C-52.25,-12.38 -55.19,-8.68 -59.44,-5.39C-62.23,-3.239 -65.15,-1.439 -68.23,0C-67.47,-0.01 -66.71,-0.04 -65.96,-0.08C-25.94,-2.069 5.89,-35.14 5.89,-75.65C5.89,-86.04 3.79,-95.939 0,-104.96",
    style: {
      fillRule: 'nonzero'
    }
  })))));
};

var styles$q = {"path":"storyliner-6EOm0u-y"};

// import node_modules

var Logo = function Logo() {
  return React.createElement("svg", {
    // xmlnsserif="http://www.serif.com/"
    height: "100%",
    version: "1.1",
    viewBox: "0 0 2827 947",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,-5204.1,-1605.94)"
  }, React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,235.12,554.72)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,-35.739L-1.23,-37.8L-8.63,-31.219C-10.27,-29.849 -12.19,-27.319 -14.38,-23.62C-16.58,-19.92 -18.29,-16.16 -19.52,-12.319C-20.75,-8.489 -21.03,-5.13 -20.34,-2.25C-19.66,0.62 -17.26,2.061 -13.15,2.061C-10.68,2.061 -8.15,1.101 -5.55,-0.809C-2.95,-2.729 -0.82,-5.399 0.82,-8.83C2.47,-12.26 3.35,-16.29 3.49,-20.95C3.63,-25.609 2.47,-30.54 0,-35.739",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,217.86,455.95)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,63.85L12.74,53.991C10.55,49.88 8.22,45.43 5.75,40.63C3.29,35.84 1.16,30.97 -0.62,26.04C-2.4,21.11 -3.56,16.11 -4.11,11.04C-4.66,5.98 -4.25,1.11 -2.88,-3.55C-1.23,-9.02 1.44,-14.16 5.14,-18.96C8.84,-23.75 12.95,-27.86 17.47,-31.29C21.29,-34.18 25.1,-36.62 28.92,-38.64C25.56,-39.1 22.12,-39.34 18.63,-39.34C-23.16,-39.34 -57.04,-5.46 -57.04,36.33C-57.04,53.26 -51.48,68.9 -42.07,81.51C-38.83,85.871 -35.12,89.86 -31.03,93.43C-26.7,97.201 -21.93,100.48 -16.82,103.19C-19.63,98.15 -19.97,92.77 -17.87,87.07C-15,79.26 -9.04,71.52 0,63.85",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,241.7,446.31)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,31.98C0.54,34.45 1.29,37.33 2.26,40.61C3.21,43.9 4.38,47.19 5.75,50.48C13.69,44.45 21.91,38.15 30.41,31.57C38.89,25 46.7,18.97 53.83,13.49C55.48,12.21 57.8,10.48 60.51,8.47C58.28,4.56 55.71,0.87 52.84,-2.56C47.62,-8.81 41.4,-14.2 34.44,-18.5C26.83,-16.13 20.29,-13.01 14.79,-9.11C9.04,-5.27 4.38,-0 0.82,6.71C-2.75,13.43 -3.02,21.85 0,31.98",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,306.27,567.93)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,-104.96C-2.65,-103.46 -4.8,-102.16 -6.22,-101.14C-13.89,-95.66 -22.18,-89.7 -31.08,-83.27C-39.99,-76.83 -48.41,-70.46 -56.35,-64.16C-54.44,-58.67 -52.73,-54.09 -51.22,-50.39C-49.72,-46.689 -48.55,-43.13 -47.72,-39.71C-46.9,-36.29 -46.7,-32.79 -47.11,-29.23C-47.52,-25.67 -48.69,-21.42 -50.6,-16.489C-52.25,-12.38 -55.19,-8.68 -59.44,-5.39C-62.23,-3.239 -65.15,-1.439 -68.23,0C-67.47,-0.01 -66.71,-0.04 -65.96,-0.08C-25.94,-2.069 5.89,-35.14 5.89,-75.65C5.89,-86.04 3.79,-95.939 0,-104.96",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,377.648,437.298)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,88.769C-0.74,90.309 -1.696,91.511 -2.867,92.375C-4.04,93.237 -5.178,93.67 -6.288,93.67C-8.137,93.67 -9.218,93.023 -9.524,91.728C-9.833,90.433 -9.709,88.922 -9.154,87.197C-8.6,85.469 -7.831,83.776 -6.842,82.112C-5.857,80.447 -4.993,79.308 -4.253,78.69L-0.925,75.731L-0.37,76.656C0.74,78.999 1.263,81.215 1.202,83.314C1.139,85.409 0.74,87.226 0,88.769M79.797,3.514C86.27,2.714 92.526,2.006 98.568,1.387C104.607,0.772 110.312,0.31 115.674,-0C121.038,-0.306 125.814,-0.398 130.006,-0.277C138.514,-0.029 145.109,0.647 149.795,1.757C154.479,2.867 157.932,4.101 160.152,5.456C162.741,6.935 164.341,8.663 164.959,10.634L168.104,6.565C170.693,4.346 171.618,2.375 170.877,0.647C170.508,-0.092 169.797,-0.832 168.75,-1.572C167.702,-2.312 166.038,-2.988 163.757,-3.606C161.475,-4.221 158.516,-4.745 154.88,-5.178C151.243,-5.608 146.772,-5.886 141.473,-6.01C136.171,-6.131 130.406,-6.039 124.182,-5.733C117.955,-5.424 111.45,-5.022 104.671,-4.531C97.889,-4.037 91.015,-3.45 84.05,-2.774C77.084,-2.095 70.209,-1.387 63.43,-0.647C63.552,-0.893 63.644,-1.138 63.708,-1.387C63.769,-1.632 63.861,-1.878 63.985,-2.127C65.216,-4.837 66.326,-7.334 67.314,-9.617C68.299,-11.897 69.164,-13.899 69.903,-15.627C70.764,-17.597 71.568,-19.325 72.307,-20.805L66.944,-3.976C67.19,-4.221 67.776,-5.299 68.701,-7.212C69.625,-9.122 70.55,-11.217 71.475,-13.501C72.4,-15.78 73.261,-17.967 74.064,-20.065C74.864,-22.16 75.267,-23.579 75.267,-24.319C75.388,-25.674 74.555,-26.937 72.77,-28.11C70.981,-29.28 68.854,-29.867 66.389,-29.867C65.156,-29.867 64.106,-29.682 63.246,-29.312C62.381,-28.942 61.518,-28.231 60.657,-27.185C59.792,-26.136 58.807,-24.625 57.698,-22.654C56.587,-20.681 55.169,-18.092 53.444,-14.887C52.456,-12.914 51.378,-10.57 50.208,-7.859C49.035,-5.146 47.833,-2.127 46.601,1.202C36.121,2.19 27.03,3.023 19.324,3.699C11.62,4.378 6.41,4.47 3.696,3.976C0.368,3.361 -2.375,2.653 -4.533,1.85C-6.689,1.049 -8.446,0.277 -9.804,-0.462C-11.284,-1.323 -12.515,-2.248 -13.502,-3.236C-15.352,-1.757 -15.936,-0 -15.26,2.035C-14.581,4.069 -13.254,5.982 -11.284,7.768C-9.31,9.556 -6.998,11.067 -4.349,12.298C-1.696,13.532 0.737,14.087 2.957,13.963C5.794,13.717 10.909,13.07 18.307,12.021C25.704,10.975 34.21,9.773 43.827,8.415C41.36,15.442 38.863,23.117 36.337,31.439C34.835,36.384 33.406,41.244 32.035,46.036C30.307,47.342 28.569,48.667 26.816,50.025C23.608,52.493 20.094,55.203 16.274,58.162C12.452,61.121 8.753,63.959 5.178,66.669C4.56,65.19 4.037,63.71 3.606,62.231C3.173,60.751 2.834,59.457 2.589,58.347C1.231,53.788 1.355,49.996 2.959,46.974C4.56,43.954 6.658,41.581 9.247,39.854C12.206,37.759 15.841,36.155 20.158,35.045C19.418,33.936 18.615,32.89 17.754,31.902C17.014,31.162 16.089,30.454 14.979,29.774C13.87,29.099 12.576,28.821 11.096,28.943C9.617,28.943 7.86,29.436 5.826,30.422C3.792,31.41 1.757,32.673 -0.277,34.213C-2.312,35.756 -4.161,37.605 -5.826,39.761C-7.49,41.92 -8.692,44.231 -9.432,46.696C-10.05,48.794 -10.235,50.982 -9.986,53.261C-9.741,55.544 -9.218,57.792 -8.415,60.012C-7.614,62.231 -6.658,64.421 -5.548,66.577C-4.438,68.735 -3.392,70.738 -2.404,72.587L-8.137,77.026C-12.206,80.479 -14.887,83.96 -16.182,87.474C-17.477,90.989 -16.705,94.225 -13.87,97.184C-12.27,98.909 -10.328,99.926 -8.044,100.235C-5.765,100.541 -3.514,100.328 -1.294,99.588C0.925,98.848 2.988,97.739 4.901,96.259C6.811,94.78 8.137,93.115 8.877,91.266C9.738,89.046 10.264,87.133 10.449,85.533C10.634,83.929 10.541,82.357 10.171,80.817C9.802,79.277 9.276,77.673 8.599,76.008C7.92,74.344 7.149,72.281 6.288,69.813C9.862,66.979 13.654,64.112 17.662,61.214C21.667,58.318 25.397,55.637 28.85,53.169C29.342,52.815 29.825,52.48 30.316,52.13C29.979,53.341 29.638,54.557 29.31,55.758C27.154,63.65 25.305,70.987 23.762,77.765C22.222,84.544 21.205,89.971 20.71,94.04C19.971,99.833 19.601,104.332 19.601,107.54C19.601,110.745 19.941,113.117 20.618,114.661C21.297,116.2 22.346,117.186 23.762,117.62C25.181,118.049 26.937,118.388 29.032,118.636C29.157,116.663 29.928,112.071 31.344,104.858C32.76,97.646 34.766,88.862 37.354,78.505C39.944,68.149 43.18,56.683 47.063,44.107C50.947,31.532 55.478,18.835 60.657,6.011C66.944,5.149 73.325,4.317 79.797,3.514",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,550.553,437.05)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,125.264C-2.219,130.379 -4.377,134.91 -6.472,138.858C-9.801,145.39 -12.945,150.694 -15.904,154.762C-18.863,158.83 -21.48,161.942 -23.764,164.101C-26.044,166.256 -27.953,167.615 -29.496,168.169C-31.037,168.724 -32.114,168.817 -32.732,168.447C-33.348,167.952 -33.316,166.349 -32.64,163.639C-31.962,160.925 -30.944,157.597 -29.589,153.653C-28.23,149.704 -26.168,145.668 -23.394,141.538C-20.619,137.407 -17.598,133.431 -14.332,129.61C-11.066,125.787 -7.706,122.181 -4.253,118.792C-0.803,115.399 2.341,112.472 5.18,110.007C5.549,109.759 5.979,109.389 6.474,108.898C4.376,114.692 2.221,120.147 0,125.264M93.762,-23.701C94.992,-26.536 96.102,-29.064 97.09,-31.283C98.075,-33.503 98.939,-35.473 99.68,-37.201C100.54,-39.172 101.344,-40.961 102.083,-42.564L96.721,-25.735C96.966,-25.981 97.552,-27.059 98.477,-28.972C99.401,-30.882 100.326,-32.977 101.251,-35.259C102.176,-37.54 103.036,-39.727 103.841,-41.825C104.641,-43.92 105.042,-45.339 105.042,-46.078C105.163,-47.433 104.332,-48.696 102.545,-49.869C100.757,-51.04 98.631,-51.626 96.165,-51.626C94.932,-51.626 93.883,-51.441 93.021,-51.071C92.157,-50.702 91.293,-49.991 90.432,-48.944C89.568,-47.896 88.583,-46.384 87.473,-44.414C86.363,-42.44 84.945,-39.851 83.22,-36.646C81.492,-33.318 79.336,-28.602 76.748,-22.499C74.158,-16.396 71.384,-9.553 68.425,-1.971C65.466,5.611 62.507,13.627 59.548,22.07C56.589,30.517 53.844,38.778 51.318,46.852C48.79,54.928 46.634,62.45 44.847,69.414C43.061,76.38 41.857,82.143 41.239,86.705C41.076,87.982 40.935,89.184 40.808,90.334C40.767,90.294 40.729,90.261 40.687,90.219C40.438,89.849 39.915,89.448 39.115,89.017C38.312,88.583 36.925,88.616 34.953,89.11C34.214,89.355 33.104,89.633 31.625,89.942C30.146,90.248 28.417,90.71 26.446,91.328C27.432,87.63 28.324,83.992 29.129,80.417C29.929,76.843 30.7,73.39 31.439,70.061C32.67,64.762 33.503,60.323 33.936,56.746C34.367,53.171 34.491,50.336 34.307,48.239C34.121,46.144 33.595,44.664 32.734,43.801C31.87,42.939 30.821,42.57 29.59,42.691C27.862,42.815 26.045,43.647 24.135,45.187C22.222,46.73 20.344,48.548 18.494,50.643C16.645,52.741 14.824,55.021 13.038,57.485C11.25,59.953 9.585,62.109 8.045,63.958C6.502,65.807 5.086,67.258 3.792,68.304C2.497,69.353 1.48,69.57 0.74,68.951C0.371,68.706 0.371,67.472 0.74,65.252C1.11,63.034 1.665,60.323 2.405,57.116C3.145,53.911 4.006,50.49 4.993,46.852C5.979,43.217 6.873,39.764 7.676,36.495C8.476,33.23 9.124,30.364 9.617,27.896C10.108,25.431 10.233,23.891 9.987,23.273C9.738,22.657 9.124,22.195 8.139,21.886C7.149,21.579 6.04,21.394 4.809,21.331C3.575,21.27 2.373,21.302 1.203,21.423C0.03,21.548 -0.863,21.793 -1.479,22.163C-2.097,22.533 -2.837,23.336 -3.697,24.567C-4.562,25.801 -5.455,27.157 -6.38,28.636C-7.305,30.115 -8.137,31.566 -8.877,32.982C-9.615,34.401 -10.049,35.357 -10.171,35.848C-10.54,36.836 -10.171,37.576 -9.062,38.067C-8.57,38.316 -7.952,38.501 -7.212,38.622C-7.616,40.738 -8.02,42.984 -8.421,45.347C-9.297,46.315 -10.274,47.22 -11.37,48.054C-12.665,49.042 -14.023,49.811 -15.439,50.366C-16.858,50.92 -18.12,50.952 -19.23,50.458C-20.34,49.967 -21.421,49.071 -22.467,47.777C-23.516,46.482 -24.564,45.28 -25.611,44.17C-26.66,43.06 -27.77,42.228 -28.939,41.674C-30.112,41.118 -31.436,41.275 -32.915,42.136C-33.655,42.506 -34.58,43.309 -35.689,44.54C-36.799,45.774 -37.973,47.253 -39.203,48.978C-40.437,50.706 -41.7,52.524 -42.994,54.434C-44.289,56.347 -45.491,58.164 -46.601,59.889C-47.959,61.739 -49.222,63.496 -50.392,65.16C-51.565,66.825 -52.643,68.336 -53.628,69.691C-54.738,71.17 -55.787,72.65 -56.772,74.129C-54.432,67.966 -52.272,62.294 -50.299,57.116C-49.56,54.896 -48.791,52.709 -47.987,50.55C-47.188,48.395 -46.479,46.389 -45.861,44.54C-45.245,42.691 -44.783,41.09 -44.475,39.732C-44.168,38.377 -44.012,37.391 -44.012,36.773C-44.136,35.663 -44.752,34.77 -45.861,34.091C-46.971,33.415 -48.173,32.952 -49.468,32.704C-50.762,32.459 -52.027,32.427 -53.258,32.612C-54.493,32.797 -55.356,33.198 -55.848,33.814C-56.587,34.802 -57.452,36.744 -58.436,39.639C-58.826,40.782 -59.228,42.012 -59.636,43.288C-60.934,44.282 -62.259,45.196 -63.612,46.019C-66.08,47.499 -68.763,48.826 -71.657,49.995C-74.556,51.169 -77.483,51.447 -80.442,50.828C-80.69,48.857 -81.246,47.222 -82.106,45.927C-82.97,44.633 -83.956,43.801 -85.065,43.431C-86.175,43.06 -87.316,43.217 -88.487,43.893C-89.66,44.572 -90.553,46.019 -91.168,48.239C-91.787,50.336 -91.787,52.186 -91.168,53.787C-92.647,55.885 -94.251,57.98 -95.977,60.075C-97.705,62.173 -99.461,64.022 -101.247,65.622C-103.036,67.227 -104.7,68.49 -106.24,69.414C-107.783,70.338 -109.107,70.616 -110.217,70.246C-111.326,69.876 -111.852,69.044 -111.789,67.749C-111.728,66.455 -111.265,64.823 -110.401,62.848C-109.541,60.878 -108.367,58.719 -106.888,56.376C-105.408,54.035 -103.868,51.753 -102.265,49.533C-100.169,46.699 -97.705,44.418 -94.867,42.691C-92.032,40.966 -89.998,40.226 -88.764,40.472C-87.778,40.72 -87.224,40.966 -87.099,41.211C-86.979,41.46 -86.793,41.275 -86.545,40.657C-86.423,40.411 -86.299,40.009 -86.175,39.454C-86.054,38.9 -86.022,38.285 -86.083,37.605C-86.146,36.929 -86.392,36.282 -86.822,35.663C-87.255,35.048 -87.963,34.554 -88.949,34.184C-90.183,33.693 -91.723,33.629 -93.572,33.999C-95.422,34.368 -97.396,35.357 -99.49,36.958C-100.23,37.576 -101.371,38.501 -102.912,39.732C-104.455,40.966 -106.119,42.598 -107.905,44.633C-109.693,46.667 -111.418,49.042 -113.083,51.753C-114.748,54.466 -116.134,57.485 -117.244,60.814C-117.984,63.158 -118.261,65.409 -118.076,67.565C-117.891,69.723 -117.365,71.633 -116.504,73.297C-115.641,74.962 -114.407,76.256 -112.806,77.181C-111.205,78.106 -109.292,78.447 -107.072,78.199C-104.732,78.076 -102.357,77.367 -99.953,76.072C-97.548,74.777 -95.269,73.176 -93.11,71.263C-90.954,69.353 -88.981,67.195 -87.192,64.79C-85.406,62.386 -83.834,59.889 -82.477,57.301C-78.532,57.549 -74.926,57.116 -71.657,56.006C-68.392,54.896 -65.494,53.509 -62.965,51.845C-62.636,51.628 -62.336,51.407 -62.022,51.188C-62.952,54.488 -63.796,57.936 -64.54,61.554C-65.404,65.747 -65.987,69.599 -66.296,73.113C-66.603,76.626 -66.51,79.525 -66.019,81.805C-65.528,84.084 -64.54,85.286 -63.06,85.41C-60.965,85.533 -58.807,84.177 -56.587,81.342C-54.368,78.508 -51.903,75.24 -49.189,71.54C-47.34,68.951 -45.584,66.455 -43.919,64.051C-42.254,61.647 -40.715,59.52 -39.295,57.671C-37.88,55.821 -36.646,54.342 -35.598,53.232C-34.551,52.122 -33.719,51.631 -33.101,51.753C-31.991,52.001 -31.13,52.524 -30.512,53.325C-29.896,54.128 -29.248,54.96 -28.57,55.821C-27.894,56.685 -27.029,57.393 -25.98,57.948C-24.935,58.502 -23.484,58.659 -21.635,58.41C-19.785,58.164 -17.844,57.485 -15.81,56.376C-13.774,55.266 -11.896,54.004 -10.168,52.584C-9.895,52.36 -9.64,52.133 -9.38,51.906C-9.521,52.987 -9.66,54.097 -9.801,55.266C-10.171,58.349 -10.42,61.369 -10.54,64.328C-10.789,70.494 -10.11,74.624 -8.506,76.719C-6.905,78.817 -4.687,79.678 -1.849,79.308C0.371,79.063 2.466,78.199 4.439,76.719C6.41,75.24 8.291,73.453 10.08,71.356C11.866,69.261 13.529,67.041 15.072,64.698C16.613,62.357 18.031,60.167 19.327,58.133C20.621,56.099 21.823,54.313 22.933,52.77C24.042,51.23 25.028,50.273 25.892,49.903C26.138,49.782 26.076,50.614 25.707,52.4C25.337,54.188 24.719,56.44 23.857,59.15C22.994,61.864 22.008,64.883 20.898,68.211C19.789,71.54 18.739,74.684 17.754,77.643C16.766,80.602 15.873,83.192 15.072,85.41C14.27,87.63 13.808,88.985 13.686,89.48C13.067,91.204 12.484,92.868 11.929,94.473C11.374,96.074 10.787,97.677 10.173,99.282C8.074,100.512 6.289,101.806 4.809,103.164C2.711,104.765 0.062,106.985 -3.144,109.823C-6.351,112.658 -10.11,116.416 -14.424,121.103C-20.342,127.267 -25.15,133.402 -28.85,139.504C-32.548,145.608 -35.137,151.156 -36.616,156.149C-38.096,161.142 -38.494,165.332 -37.818,168.724C-37.14,172.114 -35.322,174.18 -32.363,174.919C-24.471,176.89 -16.519,174.055 -8.506,166.412C-0.493,158.767 7.398,145.451 15.166,126.466C18.985,117.465 22.193,107.849 24.782,97.617C28.356,96.013 31.469,94.75 34.121,93.826C36.771,92.901 38.588,92.314 39.577,92.069C39.996,91.979 40.353,91.893 40.652,91.81C40.307,95.206 40.13,98.015 40.13,100.205C40.13,103.41 40.5,105.783 41.239,107.326C41.979,108.866 43.028,109.851 44.384,110.285C45.741,110.715 47.464,111.053 49.562,111.302C49.684,109.944 50.33,106.892 51.503,102.147C52.674,97.4 54.245,91.482 56.22,84.394C58.189,77.305 60.565,69.385 63.339,60.63C66.113,51.877 69.101,42.722 72.309,33.166C75.514,23.614 78.935,13.965 82.572,4.224C86.207,-5.514 89.938,-14.824 93.762,-23.701",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,649.029,465.195)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,-13.656C-1.665,-13.841 -3.237,-13.315 -4.717,-12.084C-6.196,-10.85 -7.152,-9.31 -7.583,-7.461C-8.017,-5.612 -7.739,-3.947 -6.751,-2.467C-5.766,-1.109 -4.472,-0.309 -2.867,-0.063C-1.266,0.185 0.276,-0.309 1.756,-1.543C3.235,-2.774 4.189,-4.317 4.622,-6.166C5.054,-8.016 4.775,-9.68 3.79,-11.159C2.927,-12.639 1.663,-13.471 0,-13.656",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,4534.01,0)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,838.768,506.187)"
  }, React.createElement("path", {
    className: styles$q['path'],
    d: "M0,-27.74C-0.433,-28.356 -0.955,-28.171 -1.571,-27.185C-2.065,-26.446 -2.805,-25.489 -3.79,-24.319C-4.778,-23.145 -5.918,-22.068 -7.212,-21.083C-8.506,-20.094 -9.864,-19.325 -11.28,-18.771C-12.699,-18.216 -13.962,-18.184 -15.072,-18.678C-16.182,-19.169 -17.263,-20.066 -18.308,-21.36C-19.357,-22.655 -20.406,-23.856 -21.452,-24.966C-22.501,-26.076 -23.61,-26.908 -24.78,-27.463C-25.953,-28.018 -27.277,-27.862 -28.756,-27C-29.496,-26.631 -30.421,-25.827 -31.53,-24.596C-32.64,-23.363 -33.813,-21.883 -35.045,-20.158C-36.278,-18.43 -37.541,-16.612 -38.836,-14.702C-40.131,-12.789 -41.332,-10.972 -42.441,-9.247C-43.8,-7.397 -45.063,-5.64 -46.233,-3.976C-47.406,-2.312 -48.484,-0.8 -49.47,0.554C-50.579,2.034 -51.628,3.513 -52.613,4.993C-50.273,-1.17 -48.114,-6.843 -46.141,-12.021C-45.4,-14.24 -44.632,-16.427 -43.829,-18.586C-43.029,-20.741 -42.321,-22.747 -41.702,-24.596C-41.087,-26.446 -40.624,-28.046 -40.315,-29.405C-40.009,-30.76 -39.854,-31.745 -39.854,-32.364C-39.978,-33.473 -40.593,-34.366 -41.702,-35.045C-42.813,-35.721 -44.015,-36.184 -45.309,-36.432C-46.603,-36.678 -47.868,-36.71 -49.1,-36.525C-50.334,-36.34 -51.198,-35.938 -51.688,-35.323C-52.429,-34.334 -53.293,-32.392 -54.277,-29.497C-55.199,-26.797 -56.173,-23.706 -57.198,-20.258C-59.307,-18.205 -61.415,-16.186 -63.522,-14.24C-66.235,-11.772 -69.134,-9.276 -72.214,-6.75C-75.297,-4.222 -78.011,-2.219 -80.352,-0.74C-83.681,1.358 -86.579,2.714 -89.043,3.329C-91.511,3.947 -93.574,4.068 -95.238,3.699C-96.902,3.329 -98.197,2.589 -99.122,1.479C-100.047,0.37 -100.572,-0.986 -100.694,-2.589C-101.063,-5.918 -100.449,-9.4 -98.845,-13.037C-97.244,-16.673 -95.27,-19.88 -92.927,-22.655C-90.586,-25.428 -88.304,-27.431 -86.084,-28.665C-83.865,-29.896 -82.386,-29.65 -81.646,-27.925C-80.906,-25.951 -81.369,-24.01 -83.032,-22.1C-84.697,-20.187 -86.671,-18.462 -88.95,-16.921C-91.233,-15.379 -93.421,-14.148 -95.517,-13.223C-97.614,-12.298 -98.66,-11.772 -98.66,-11.651C-98.908,-11.157 -98.969,-10.787 -98.845,-10.541C-98.724,-10.293 -98.383,-10.079 -97.827,-9.894C-97.273,-9.709 -96.319,-9.738 -94.961,-9.986C-93.606,-10.108 -91.849,-10.541 -89.69,-11.281C-87.535,-12.021 -85.5,-13.098 -83.588,-14.517C-81.678,-15.933 -80.073,-17.629 -78.779,-19.603C-77.485,-21.573 -77.022,-23.856 -77.393,-26.446C-77.763,-29.526 -78.964,-31.592 -80.998,-32.641C-83.032,-33.687 -85.469,-33.872 -88.304,-33.196C-91.141,-32.517 -94.1,-31.037 -97.18,-28.757C-100.264,-26.474 -102.977,-23.487 -105.318,-19.788C-106.424,-18.066 -107.529,-15.794 -108.635,-12.972C-109.617,-11.848 -110.636,-10.701 -111.698,-9.524C-113.98,-6.996 -116.229,-4.744 -118.448,-2.774C-120.667,-0.8 -122.766,0.803 -124.735,2.034C-126.71,3.268 -128.312,3.699 -129.544,3.329C-130.653,2.959 -131.332,2.098 -131.578,0.74C-131.827,-0.615 -131.948,-2.28 -131.948,-4.253C-131.948,-6.224 -131.92,-8.322 -131.855,-10.541C-131.795,-12.761 -131.948,-14.795 -132.318,-16.644C-132.688,-18.493 -133.398,-20.033 -134.445,-21.267C-135.494,-22.498 -137.065,-23.117 -139.16,-23.117C-141.38,-23.117 -143.6,-22.377 -145.818,-20.897C-148.037,-19.418 -150.196,-17.597 -152.292,-15.442C-154.389,-13.283 -156.33,-10.911 -158.117,-8.322C-159.905,-5.733 -161.538,-3.329 -163.017,-1.11C-164.497,1.11 -165.699,2.93 -166.624,4.346C-167.549,5.764 -168.135,6.412 -168.381,6.288C-168.875,6.167 -168.75,4.965 -168.011,2.682C-167.271,0.402 -166.285,-2.433 -165.052,-5.825C-163.821,-9.215 -162.463,-12.882 -160.982,-16.829C-159.504,-20.773 -158.148,-24.532 -156.914,-28.11C-155.684,-31.684 -154.759,-34.768 -154.141,-37.357C-153.525,-39.946 -153.465,-41.611 -153.955,-42.35C-154.326,-42.842 -155.004,-43.243 -155.989,-43.553C-156.979,-43.859 -158.088,-44.075 -159.319,-44.199C-160.553,-44.321 -161.723,-44.321 -162.832,-44.199C-163.941,-44.075 -164.806,-43.829 -165.422,-43.459C-166.04,-43.09 -166.78,-42.286 -167.641,-41.055C-168.505,-39.822 -169.397,-38.466 -170.322,-36.987C-171.247,-35.507 -172.079,-34.089 -172.818,-32.734C-173.559,-31.375 -173.992,-30.45 -174.113,-29.959C-174.483,-28.971 -174.238,-28.232 -173.374,-27.74C-173.004,-27.491 -172.573,-27.307 -172.079,-27.185C-172.293,-26.461 -172.501,-25.759 -172.71,-25.053C-177.954,-18.654 -182.802,-12.95 -187.242,-7.952C-189.341,-5.609 -191.403,-3.297 -193.437,-1.017C-195.472,1.265 -197.321,3.268 -198.986,4.993C-200.649,6.721 -202.069,8.077 -203.239,9.062C-204.413,10.051 -205.182,10.42 -205.551,10.172C-206.046,9.927 -206.105,8.877 -205.736,7.027C-205.366,5.178 -204.719,2.867 -203.795,0.093C-202.87,-2.681 -201.791,-5.701 -200.558,-8.969C-199.327,-12.235 -198.153,-15.349 -197.044,-18.308C-195.935,-21.267 -194.949,-23.824 -194.085,-25.983C-193.225,-28.139 -192.669,-29.59 -192.421,-30.329C-192.175,-31.315 -192.235,-32.086 -192.605,-32.641C-192.976,-33.196 -193.53,-33.594 -194.27,-33.843C-195.01,-34.089 -195.873,-34.273 -196.859,-34.398C-197.847,-34.519 -198.832,-34.643 -199.818,-34.768C-200.928,-34.889 -202.162,-33.687 -203.517,-31.161C-204.875,-28.633 -206.23,-25.614 -207.585,-22.1C-208.943,-18.586 -210.238,-14.887 -211.469,-11.003C-212.7,-7.12 -213.687,-3.884 -214.428,-1.294C-215.043,0.925 -215.381,3.084 -215.444,5.178C-215.506,7.276 -215.229,9.155 -214.612,10.819C-213.994,12.483 -213.009,13.839 -211.653,14.887C-210.299,15.933 -208.573,16.46 -206.476,16.46C-204.996,16.581 -203.087,15.688 -200.742,13.778C-198.402,11.868 -195.842,9.431 -193.068,6.472C-190.294,3.513 -187.491,0.309 -184.653,-3.144C-181.818,-6.594 -179.262,-9.862 -176.979,-12.945C-176.62,-13.429 -176.287,-13.881 -175.948,-14.342C-176.791,-11.559 -177.575,-8.835 -178.274,-6.195C-179.078,-3.173 -179.661,-0.8 -180.031,0.925C-181.018,5.488 -181.109,9.218 -180.31,12.113C-179.505,15.009 -177.382,16.335 -173.929,16.09C-172.203,15.966 -170.386,15.101 -168.473,13.501C-166.563,11.899 -164.653,9.894 -162.74,7.49C-160.83,5.086 -158.948,2.529 -157.1,-0.185C-155.251,-2.895 -153.493,-5.424 -151.829,-7.767C-150.164,-10.108 -148.624,-12.05 -147.205,-13.593C-145.79,-15.133 -144.524,-15.965 -143.414,-16.089C-142.923,-16.089 -142.706,-15.442 -142.767,-14.148C-142.831,-12.853 -142.923,-11.249 -143.044,-9.339C-143.168,-7.426 -143.229,-5.331 -143.229,-3.051C-143.229,-0.769 -142.952,1.358 -142.397,3.329C-141.842,5.302 -140.981,6.999 -139.808,8.415C-138.638,9.834 -136.881,10.605 -134.537,10.726C-132.196,10.975 -129.637,10.296 -126.862,8.692C-124.088,7.092 -121.285,5.025 -118.448,2.497C-115.701,0.05 -113.012,-2.666 -110.38,-5.638C-110.423,-5.177 -110.477,-4.717 -110.496,-4.253C-110.617,-1.294 -109.94,1.479 -108.462,4.068C-106.981,6.658 -104.207,8.447 -100.139,9.431C-97.551,10.051 -94.9,10.079 -92.187,9.524C-89.477,8.969 -86.764,8.045 -84.05,6.751C-81.339,5.456 -78.687,3.855 -76.098,1.942C-73.509,0.032 -71.044,-1.97 -68.7,-4.069C-65.42,-7.05 -62.162,-10.354 -58.927,-13.968C-59.445,-11.896 -59.932,-9.77 -60.381,-7.582C-61.245,-3.389 -61.829,0.463 -62.138,3.976C-62.443,7.49 -62.352,10.388 -61.86,12.669C-61.369,14.948 -60.381,16.15 -58.901,16.274C-56.806,16.396 -54.647,15.041 -52.429,12.206C-50.209,9.372 -47.744,6.103 -45.031,2.404C-43.182,-0.185 -41.425,-2.681 -39.76,-5.085C-38.096,-7.49 -36.556,-9.616 -35.137,-11.466C-33.721,-13.315 -32.487,-14.795 -31.438,-15.904C-30.393,-17.014 -29.561,-17.505 -28.942,-17.384C-27.832,-17.135 -26.971,-16.612 -26.353,-15.812C-25.737,-15.009 -25.09,-14.176 -24.411,-13.315C-23.734,-12.451 -22.87,-11.743 -21.822,-11.189C-20.775,-10.634 -19.325,-10.478 -17.476,-10.726C-15.626,-10.972 -13.685,-11.651 -11.65,-12.761C-9.615,-13.87 -7.737,-15.133 -6.01,-16.552C-4.285,-17.968 -2.837,-19.418 -1.663,-20.897C-0.493,-22.377 0.154,-23.608 0.278,-24.596C0.523,-26.076 0.432,-27.122 0,-27.74",
    style: {
      fillRule: 'nonzero'
    }
  })))));
};

Logo.displayName = 'Logo';

var styles$p = {"path":"storyliner-bsujdUt4"};

// import node_modules

var LogoLettering = function LogoLettering() {
  return React.createElement("svg", {
    // xmlnsSerif="http://www.serif.com/"
    height: "100%",
    version: "1.1",
    viewBox: "0 0 1994 947",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2
    }
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,-10196.1,-1610.1)"
  }, React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,8692.49,4.16618)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,377.648,437.298)"
  }, React.createElement("path", {
    className: styles$p['path'],
    d: "M0,88.769C-0.74,90.309 -1.696,91.511 -2.867,92.375C-4.04,93.237 -5.178,93.67 -6.288,93.67C-8.137,93.67 -9.218,93.023 -9.524,91.728C-9.833,90.433 -9.709,88.922 -9.154,87.197C-8.6,85.469 -7.831,83.776 -6.842,82.112C-5.857,80.447 -4.993,79.308 -4.253,78.69L-0.925,75.731L-0.37,76.656C0.74,78.999 1.263,81.215 1.202,83.314C1.139,85.409 0.74,87.226 0,88.769M79.797,3.514C86.27,2.714 92.526,2.006 98.568,1.387C104.607,0.772 110.312,0.31 115.674,-0C121.038,-0.306 125.814,-0.398 130.006,-0.277C138.514,-0.029 145.109,0.647 149.795,1.757C154.479,2.867 157.932,4.101 160.152,5.456C162.741,6.935 164.341,8.663 164.959,10.634L168.104,6.565C170.693,4.346 171.618,2.375 170.877,0.647C170.508,-0.092 169.797,-0.832 168.75,-1.572C167.702,-2.312 166.038,-2.988 163.757,-3.606C161.475,-4.221 158.516,-4.745 154.88,-5.178C151.243,-5.608 146.772,-5.886 141.473,-6.01C136.171,-6.131 130.406,-6.039 124.182,-5.733C117.955,-5.424 111.45,-5.022 104.671,-4.531C97.889,-4.037 91.015,-3.45 84.05,-2.774C77.084,-2.095 70.209,-1.387 63.43,-0.647C63.552,-0.893 63.644,-1.138 63.708,-1.387C63.769,-1.632 63.861,-1.878 63.985,-2.127C65.216,-4.837 66.326,-7.334 67.314,-9.617C68.299,-11.897 69.164,-13.899 69.903,-15.627C70.764,-17.597 71.568,-19.325 72.307,-20.805L66.944,-3.976C67.19,-4.221 67.776,-5.299 68.701,-7.212C69.625,-9.122 70.55,-11.217 71.475,-13.501C72.4,-15.78 73.261,-17.967 74.064,-20.065C74.864,-22.16 75.267,-23.579 75.267,-24.319C75.388,-25.674 74.555,-26.937 72.77,-28.11C70.981,-29.28 68.854,-29.867 66.389,-29.867C65.156,-29.867 64.106,-29.682 63.246,-29.312C62.381,-28.942 61.518,-28.231 60.657,-27.185C59.792,-26.136 58.807,-24.625 57.698,-22.654C56.587,-20.681 55.169,-18.092 53.444,-14.887C52.456,-12.914 51.378,-10.57 50.208,-7.859C49.035,-5.146 47.833,-2.127 46.601,1.202C36.121,2.19 27.03,3.023 19.324,3.699C11.62,4.378 6.41,4.47 3.696,3.976C0.368,3.361 -2.375,2.653 -4.533,1.85C-6.689,1.049 -8.446,0.277 -9.804,-0.462C-11.284,-1.323 -12.515,-2.248 -13.502,-3.236C-15.352,-1.757 -15.936,-0 -15.26,2.035C-14.581,4.069 -13.254,5.982 -11.284,7.768C-9.31,9.556 -6.998,11.067 -4.349,12.298C-1.696,13.532 0.737,14.087 2.957,13.963C5.794,13.717 10.909,13.07 18.307,12.021C25.704,10.975 34.21,9.773 43.827,8.415C41.36,15.442 38.863,23.117 36.337,31.439C34.835,36.384 33.406,41.244 32.035,46.036C30.307,47.342 28.569,48.667 26.816,50.025C23.608,52.493 20.094,55.203 16.274,58.162C12.452,61.121 8.753,63.959 5.178,66.669C4.56,65.19 4.037,63.71 3.606,62.231C3.173,60.751 2.834,59.457 2.589,58.347C1.231,53.788 1.355,49.996 2.959,46.974C4.56,43.954 6.658,41.581 9.247,39.854C12.206,37.759 15.841,36.155 20.158,35.045C19.418,33.936 18.615,32.89 17.754,31.902C17.014,31.162 16.089,30.454 14.979,29.774C13.87,29.099 12.576,28.821 11.096,28.943C9.617,28.943 7.86,29.436 5.826,30.422C3.792,31.41 1.757,32.673 -0.277,34.213C-2.312,35.756 -4.161,37.605 -5.826,39.761C-7.49,41.92 -8.692,44.231 -9.432,46.696C-10.05,48.794 -10.235,50.982 -9.986,53.261C-9.741,55.544 -9.218,57.792 -8.415,60.012C-7.614,62.231 -6.658,64.421 -5.548,66.577C-4.438,68.735 -3.392,70.738 -2.404,72.587L-8.137,77.026C-12.206,80.479 -14.887,83.96 -16.182,87.474C-17.477,90.989 -16.705,94.225 -13.87,97.184C-12.27,98.909 -10.328,99.926 -8.044,100.235C-5.765,100.541 -3.514,100.328 -1.294,99.588C0.925,98.848 2.988,97.739 4.901,96.259C6.811,94.78 8.137,93.115 8.877,91.266C9.738,89.046 10.264,87.133 10.449,85.533C10.634,83.929 10.541,82.357 10.171,80.817C9.802,79.277 9.276,77.673 8.599,76.008C7.92,74.344 7.149,72.281 6.288,69.813C9.862,66.979 13.654,64.112 17.662,61.214C21.667,58.318 25.397,55.637 28.85,53.169C29.342,52.815 29.825,52.48 30.316,52.13C29.979,53.341 29.638,54.557 29.31,55.758C27.154,63.65 25.305,70.987 23.762,77.765C22.222,84.544 21.205,89.971 20.71,94.04C19.971,99.833 19.601,104.332 19.601,107.54C19.601,110.745 19.941,113.117 20.618,114.661C21.297,116.2 22.346,117.186 23.762,117.62C25.181,118.049 26.937,118.388 29.032,118.636C29.157,116.663 29.928,112.071 31.344,104.858C32.76,97.646 34.766,88.862 37.354,78.505C39.944,68.149 43.18,56.683 47.063,44.107C50.947,31.532 55.478,18.835 60.657,6.011C66.944,5.149 73.325,4.317 79.797,3.514",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,8692.49,4.16618)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,550.553,437.05)"
  }, React.createElement("path", {
    className: styles$p['path'],
    d: "M0,125.264C-2.219,130.379 -4.377,134.91 -6.472,138.858C-9.801,145.39 -12.945,150.694 -15.904,154.762C-18.863,158.83 -21.48,161.942 -23.764,164.101C-26.044,166.256 -27.953,167.615 -29.496,168.169C-31.037,168.724 -32.114,168.817 -32.732,168.447C-33.348,167.952 -33.316,166.349 -32.64,163.639C-31.962,160.925 -30.944,157.597 -29.589,153.653C-28.23,149.704 -26.168,145.668 -23.394,141.538C-20.619,137.407 -17.598,133.431 -14.332,129.61C-11.066,125.787 -7.706,122.181 -4.253,118.792C-0.803,115.399 2.341,112.472 5.18,110.007C5.549,109.759 5.979,109.389 6.474,108.898C4.376,114.692 2.221,120.147 0,125.264M93.762,-23.701C94.992,-26.536 96.102,-29.064 97.09,-31.283C98.075,-33.503 98.939,-35.473 99.68,-37.201C100.54,-39.172 101.344,-40.961 102.083,-42.564L96.721,-25.735C96.966,-25.981 97.552,-27.059 98.477,-28.972C99.401,-30.882 100.326,-32.977 101.251,-35.259C102.176,-37.54 103.036,-39.727 103.841,-41.825C104.641,-43.92 105.042,-45.339 105.042,-46.078C105.163,-47.433 104.332,-48.696 102.545,-49.869C100.757,-51.04 98.631,-51.626 96.165,-51.626C94.932,-51.626 93.883,-51.441 93.021,-51.071C92.157,-50.702 91.293,-49.991 90.432,-48.944C89.568,-47.896 88.583,-46.384 87.473,-44.414C86.363,-42.44 84.945,-39.851 83.22,-36.646C81.492,-33.318 79.336,-28.602 76.748,-22.499C74.158,-16.396 71.384,-9.553 68.425,-1.971C65.466,5.611 62.507,13.627 59.548,22.07C56.589,30.517 53.844,38.778 51.318,46.852C48.79,54.928 46.634,62.45 44.847,69.414C43.061,76.38 41.857,82.143 41.239,86.705C41.076,87.982 40.935,89.184 40.808,90.334C40.767,90.294 40.729,90.261 40.687,90.219C40.438,89.849 39.915,89.448 39.115,89.017C38.312,88.583 36.925,88.616 34.953,89.11C34.214,89.355 33.104,89.633 31.625,89.942C30.146,90.248 28.417,90.71 26.446,91.328C27.432,87.63 28.324,83.992 29.129,80.417C29.929,76.843 30.7,73.39 31.439,70.061C32.67,64.762 33.503,60.323 33.936,56.746C34.367,53.171 34.491,50.336 34.307,48.239C34.121,46.144 33.595,44.664 32.734,43.801C31.87,42.939 30.821,42.57 29.59,42.691C27.862,42.815 26.045,43.647 24.135,45.187C22.222,46.73 20.344,48.548 18.494,50.643C16.645,52.741 14.824,55.021 13.038,57.485C11.25,59.953 9.585,62.109 8.045,63.958C6.502,65.807 5.086,67.258 3.792,68.304C2.497,69.353 1.48,69.57 0.74,68.951C0.371,68.706 0.371,67.472 0.74,65.252C1.11,63.034 1.665,60.323 2.405,57.116C3.145,53.911 4.006,50.49 4.993,46.852C5.979,43.217 6.873,39.764 7.676,36.495C8.476,33.23 9.124,30.364 9.617,27.896C10.108,25.431 10.233,23.891 9.987,23.273C9.738,22.657 9.124,22.195 8.139,21.886C7.149,21.579 6.04,21.394 4.809,21.331C3.575,21.27 2.373,21.302 1.203,21.423C0.03,21.548 -0.863,21.793 -1.479,22.163C-2.097,22.533 -2.837,23.336 -3.697,24.567C-4.562,25.801 -5.455,27.157 -6.38,28.636C-7.305,30.115 -8.137,31.566 -8.877,32.982C-9.615,34.401 -10.049,35.357 -10.171,35.848C-10.54,36.836 -10.171,37.576 -9.062,38.067C-8.57,38.316 -7.952,38.501 -7.212,38.622C-7.616,40.738 -8.02,42.984 -8.421,45.347C-9.297,46.315 -10.274,47.22 -11.37,48.054C-12.665,49.042 -14.023,49.811 -15.439,50.366C-16.858,50.92 -18.12,50.952 -19.23,50.458C-20.34,49.967 -21.421,49.071 -22.467,47.777C-23.516,46.482 -24.564,45.28 -25.611,44.17C-26.66,43.06 -27.77,42.228 -28.939,41.674C-30.112,41.118 -31.436,41.275 -32.915,42.136C-33.655,42.506 -34.58,43.309 -35.689,44.54C-36.799,45.774 -37.973,47.253 -39.203,48.978C-40.437,50.706 -41.7,52.524 -42.994,54.434C-44.289,56.347 -45.491,58.164 -46.601,59.889C-47.959,61.739 -49.222,63.496 -50.392,65.16C-51.565,66.825 -52.643,68.336 -53.628,69.691C-54.738,71.17 -55.787,72.65 -56.772,74.129C-54.432,67.966 -52.272,62.294 -50.299,57.116C-49.56,54.896 -48.791,52.709 -47.987,50.55C-47.188,48.395 -46.479,46.389 -45.861,44.54C-45.245,42.691 -44.783,41.09 -44.475,39.732C-44.168,38.377 -44.012,37.391 -44.012,36.773C-44.136,35.663 -44.752,34.77 -45.861,34.091C-46.971,33.415 -48.173,32.952 -49.468,32.704C-50.762,32.459 -52.027,32.427 -53.258,32.612C-54.493,32.797 -55.356,33.198 -55.848,33.814C-56.587,34.802 -57.452,36.744 -58.436,39.639C-58.826,40.782 -59.228,42.012 -59.636,43.288C-60.934,44.282 -62.259,45.196 -63.612,46.019C-66.08,47.499 -68.763,48.826 -71.657,49.995C-74.556,51.169 -77.483,51.447 -80.442,50.828C-80.69,48.857 -81.246,47.222 -82.106,45.927C-82.97,44.633 -83.956,43.801 -85.065,43.431C-86.175,43.06 -87.316,43.217 -88.487,43.893C-89.66,44.572 -90.553,46.019 -91.168,48.239C-91.787,50.336 -91.787,52.186 -91.168,53.787C-92.647,55.885 -94.251,57.98 -95.977,60.075C-97.705,62.173 -99.461,64.022 -101.247,65.622C-103.036,67.227 -104.7,68.49 -106.24,69.414C-107.783,70.338 -109.107,70.616 -110.217,70.246C-111.326,69.876 -111.852,69.044 -111.789,67.749C-111.728,66.455 -111.265,64.823 -110.401,62.848C-109.541,60.878 -108.367,58.719 -106.888,56.376C-105.408,54.035 -103.868,51.753 -102.265,49.533C-100.169,46.699 -97.705,44.418 -94.867,42.691C-92.032,40.966 -89.998,40.226 -88.764,40.472C-87.778,40.72 -87.224,40.966 -87.099,41.211C-86.979,41.46 -86.793,41.275 -86.545,40.657C-86.423,40.411 -86.299,40.009 -86.175,39.454C-86.054,38.9 -86.022,38.285 -86.083,37.605C-86.146,36.929 -86.392,36.282 -86.822,35.663C-87.255,35.048 -87.963,34.554 -88.949,34.184C-90.183,33.693 -91.723,33.629 -93.572,33.999C-95.422,34.368 -97.396,35.357 -99.49,36.958C-100.23,37.576 -101.371,38.501 -102.912,39.732C-104.455,40.966 -106.119,42.598 -107.905,44.633C-109.693,46.667 -111.418,49.042 -113.083,51.753C-114.748,54.466 -116.134,57.485 -117.244,60.814C-117.984,63.158 -118.261,65.409 -118.076,67.565C-117.891,69.723 -117.365,71.633 -116.504,73.297C-115.641,74.962 -114.407,76.256 -112.806,77.181C-111.205,78.106 -109.292,78.447 -107.072,78.199C-104.732,78.076 -102.357,77.367 -99.953,76.072C-97.548,74.777 -95.269,73.176 -93.11,71.263C-90.954,69.353 -88.981,67.195 -87.192,64.79C-85.406,62.386 -83.834,59.889 -82.477,57.301C-78.532,57.549 -74.926,57.116 -71.657,56.006C-68.392,54.896 -65.494,53.509 -62.965,51.845C-62.636,51.628 -62.336,51.407 -62.022,51.188C-62.952,54.488 -63.796,57.936 -64.54,61.554C-65.404,65.747 -65.987,69.599 -66.296,73.113C-66.603,76.626 -66.51,79.525 -66.019,81.805C-65.528,84.084 -64.54,85.286 -63.06,85.41C-60.965,85.533 -58.807,84.177 -56.587,81.342C-54.368,78.508 -51.903,75.24 -49.189,71.54C-47.34,68.951 -45.584,66.455 -43.919,64.051C-42.254,61.647 -40.715,59.52 -39.295,57.671C-37.88,55.821 -36.646,54.342 -35.598,53.232C-34.551,52.122 -33.719,51.631 -33.101,51.753C-31.991,52.001 -31.13,52.524 -30.512,53.325C-29.896,54.128 -29.248,54.96 -28.57,55.821C-27.894,56.685 -27.029,57.393 -25.98,57.948C-24.935,58.502 -23.484,58.659 -21.635,58.41C-19.785,58.164 -17.844,57.485 -15.81,56.376C-13.774,55.266 -11.896,54.004 -10.168,52.584C-9.895,52.36 -9.64,52.133 -9.38,51.906C-9.521,52.987 -9.66,54.097 -9.801,55.266C-10.171,58.349 -10.42,61.369 -10.54,64.328C-10.789,70.494 -10.11,74.624 -8.506,76.719C-6.905,78.817 -4.687,79.678 -1.849,79.308C0.371,79.063 2.466,78.199 4.439,76.719C6.41,75.24 8.291,73.453 10.08,71.356C11.866,69.261 13.529,67.041 15.072,64.698C16.613,62.357 18.031,60.167 19.327,58.133C20.621,56.099 21.823,54.313 22.933,52.77C24.042,51.23 25.028,50.273 25.892,49.903C26.138,49.782 26.076,50.614 25.707,52.4C25.337,54.188 24.719,56.44 23.857,59.15C22.994,61.864 22.008,64.883 20.898,68.211C19.789,71.54 18.739,74.684 17.754,77.643C16.766,80.602 15.873,83.192 15.072,85.41C14.27,87.63 13.808,88.985 13.686,89.48C13.067,91.204 12.484,92.868 11.929,94.473C11.374,96.074 10.787,97.677 10.173,99.282C8.074,100.512 6.289,101.806 4.809,103.164C2.711,104.765 0.062,106.985 -3.144,109.823C-6.351,112.658 -10.11,116.416 -14.424,121.103C-20.342,127.267 -25.15,133.402 -28.85,139.504C-32.548,145.608 -35.137,151.156 -36.616,156.149C-38.096,161.142 -38.494,165.332 -37.818,168.724C-37.14,172.114 -35.322,174.18 -32.363,174.919C-24.471,176.89 -16.519,174.055 -8.506,166.412C-0.493,158.767 7.398,145.451 15.166,126.466C18.985,117.465 22.193,107.849 24.782,97.617C28.356,96.013 31.469,94.75 34.121,93.826C36.771,92.901 38.588,92.314 39.577,92.069C39.996,91.979 40.353,91.893 40.652,91.81C40.307,95.206 40.13,98.015 40.13,100.205C40.13,103.41 40.5,105.783 41.239,107.326C41.979,108.866 43.028,109.851 44.384,110.285C45.741,110.715 47.464,111.053 49.562,111.302C49.684,109.944 50.33,106.892 51.503,102.147C52.674,97.4 54.245,91.482 56.22,84.394C58.189,77.305 60.565,69.385 63.339,60.63C66.113,51.877 69.101,42.722 72.309,33.166C75.514,23.614 78.935,13.965 82.572,4.224C86.207,-5.514 89.938,-14.824 93.762,-23.701",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,8692.49,4.16618)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,649.029,465.195)"
  }, React.createElement("path", {
    className: styles$p['path'],
    d: "M0,-13.656C-1.665,-13.841 -3.237,-13.315 -4.717,-12.084C-6.196,-10.85 -7.152,-9.31 -7.583,-7.461C-8.017,-5.612 -7.739,-3.947 -6.751,-2.467C-5.766,-1.109 -4.472,-0.309 -2.867,-0.063C-1.266,0.185 0.276,-0.309 1.756,-1.543C3.235,-2.774 4.189,-4.317 4.622,-6.166C5.054,-8.016 4.775,-9.68 3.79,-11.159C2.927,-12.639 1.663,-13.471 0,-13.656",
    style: {
      fillRule: 'nonzero'
    }
  }))), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,8692.49,4.16618)"
  }, React.createElement("g", {
    transform: "matrix(1,0,0,1,838.768,506.187)"
  }, React.createElement("path", {
    className: styles$p['path'],
    d: "M0,-27.74C-0.433,-28.356 -0.955,-28.171 -1.571,-27.185C-2.065,-26.446 -2.805,-25.489 -3.79,-24.319C-4.778,-23.145 -5.918,-22.068 -7.212,-21.083C-8.506,-20.094 -9.864,-19.325 -11.28,-18.771C-12.699,-18.216 -13.962,-18.184 -15.072,-18.678C-16.182,-19.169 -17.263,-20.066 -18.308,-21.36C-19.357,-22.655 -20.406,-23.856 -21.452,-24.966C-22.501,-26.076 -23.61,-26.908 -24.78,-27.463C-25.953,-28.018 -27.277,-27.862 -28.756,-27C-29.496,-26.631 -30.421,-25.827 -31.53,-24.596C-32.64,-23.363 -33.813,-21.883 -35.045,-20.158C-36.278,-18.43 -37.541,-16.612 -38.836,-14.702C-40.131,-12.789 -41.332,-10.972 -42.441,-9.247C-43.8,-7.397 -45.063,-5.64 -46.233,-3.976C-47.406,-2.312 -48.484,-0.8 -49.47,0.554C-50.579,2.034 -51.628,3.513 -52.613,4.993C-50.273,-1.17 -48.114,-6.843 -46.141,-12.021C-45.4,-14.24 -44.632,-16.427 -43.829,-18.586C-43.029,-20.741 -42.321,-22.747 -41.702,-24.596C-41.087,-26.446 -40.624,-28.046 -40.315,-29.405C-40.009,-30.76 -39.854,-31.745 -39.854,-32.364C-39.978,-33.473 -40.593,-34.366 -41.702,-35.045C-42.813,-35.721 -44.015,-36.184 -45.309,-36.432C-46.603,-36.678 -47.868,-36.71 -49.1,-36.525C-50.334,-36.34 -51.198,-35.938 -51.688,-35.323C-52.429,-34.334 -53.293,-32.392 -54.277,-29.497C-55.199,-26.797 -56.173,-23.706 -57.198,-20.258C-59.307,-18.205 -61.415,-16.186 -63.522,-14.24C-66.235,-11.772 -69.134,-9.276 -72.214,-6.75C-75.297,-4.222 -78.011,-2.219 -80.352,-0.74C-83.681,1.358 -86.579,2.714 -89.043,3.329C-91.511,3.947 -93.574,4.068 -95.238,3.699C-96.902,3.329 -98.197,2.589 -99.122,1.479C-100.047,0.37 -100.572,-0.986 -100.694,-2.589C-101.063,-5.918 -100.449,-9.4 -98.845,-13.037C-97.244,-16.673 -95.27,-19.88 -92.927,-22.655C-90.586,-25.428 -88.304,-27.431 -86.084,-28.665C-83.865,-29.896 -82.386,-29.65 -81.646,-27.925C-80.906,-25.951 -81.369,-24.01 -83.032,-22.1C-84.697,-20.187 -86.671,-18.462 -88.95,-16.921C-91.233,-15.379 -93.421,-14.148 -95.517,-13.223C-97.614,-12.298 -98.66,-11.772 -98.66,-11.651C-98.908,-11.157 -98.969,-10.787 -98.845,-10.541C-98.724,-10.293 -98.383,-10.079 -97.827,-9.894C-97.273,-9.709 -96.319,-9.738 -94.961,-9.986C-93.606,-10.108 -91.849,-10.541 -89.69,-11.281C-87.535,-12.021 -85.5,-13.098 -83.588,-14.517C-81.678,-15.933 -80.073,-17.629 -78.779,-19.603C-77.485,-21.573 -77.022,-23.856 -77.393,-26.446C-77.763,-29.526 -78.964,-31.592 -80.998,-32.641C-83.032,-33.687 -85.469,-33.872 -88.304,-33.196C-91.141,-32.517 -94.1,-31.037 -97.18,-28.757C-100.264,-26.474 -102.977,-23.487 -105.318,-19.788C-106.424,-18.066 -107.529,-15.794 -108.635,-12.972C-109.617,-11.848 -110.636,-10.701 -111.698,-9.524C-113.98,-6.996 -116.229,-4.744 -118.448,-2.774C-120.667,-0.8 -122.766,0.803 -124.735,2.034C-126.71,3.268 -128.312,3.699 -129.544,3.329C-130.653,2.959 -131.332,2.098 -131.578,0.74C-131.827,-0.615 -131.948,-2.28 -131.948,-4.253C-131.948,-6.224 -131.92,-8.322 -131.855,-10.541C-131.795,-12.761 -131.948,-14.795 -132.318,-16.644C-132.688,-18.493 -133.398,-20.033 -134.445,-21.267C-135.494,-22.498 -137.065,-23.117 -139.16,-23.117C-141.38,-23.117 -143.6,-22.377 -145.818,-20.897C-148.037,-19.418 -150.196,-17.597 -152.292,-15.442C-154.389,-13.283 -156.33,-10.911 -158.117,-8.322C-159.905,-5.733 -161.538,-3.329 -163.017,-1.11C-164.497,1.11 -165.699,2.93 -166.624,4.346C-167.549,5.764 -168.135,6.412 -168.381,6.288C-168.875,6.167 -168.75,4.965 -168.011,2.682C-167.271,0.402 -166.285,-2.433 -165.052,-5.825C-163.821,-9.215 -162.463,-12.882 -160.982,-16.829C-159.504,-20.773 -158.148,-24.532 -156.914,-28.11C-155.684,-31.684 -154.759,-34.768 -154.141,-37.357C-153.525,-39.946 -153.465,-41.611 -153.955,-42.35C-154.326,-42.842 -155.004,-43.243 -155.989,-43.553C-156.979,-43.859 -158.088,-44.075 -159.319,-44.199C-160.553,-44.321 -161.723,-44.321 -162.832,-44.199C-163.941,-44.075 -164.806,-43.829 -165.422,-43.459C-166.04,-43.09 -166.78,-42.286 -167.641,-41.055C-168.505,-39.822 -169.397,-38.466 -170.322,-36.987C-171.247,-35.507 -172.079,-34.089 -172.818,-32.734C-173.559,-31.375 -173.992,-30.45 -174.113,-29.959C-174.483,-28.971 -174.238,-28.232 -173.374,-27.74C-173.004,-27.491 -172.573,-27.307 -172.079,-27.185C-172.293,-26.461 -172.501,-25.759 -172.71,-25.053C-177.954,-18.654 -182.802,-12.95 -187.242,-7.952C-189.341,-5.609 -191.403,-3.297 -193.437,-1.017C-195.472,1.265 -197.321,3.268 -198.986,4.993C-200.649,6.721 -202.069,8.077 -203.239,9.062C-204.413,10.051 -205.182,10.42 -205.551,10.172C-206.046,9.927 -206.105,8.877 -205.736,7.027C-205.366,5.178 -204.719,2.867 -203.795,0.093C-202.87,-2.681 -201.791,-5.701 -200.558,-8.969C-199.327,-12.235 -198.153,-15.349 -197.044,-18.308C-195.935,-21.267 -194.949,-23.824 -194.085,-25.983C-193.225,-28.139 -192.669,-29.59 -192.421,-30.329C-192.175,-31.315 -192.235,-32.086 -192.605,-32.641C-192.976,-33.196 -193.53,-33.594 -194.27,-33.843C-195.01,-34.089 -195.873,-34.273 -196.859,-34.398C-197.847,-34.519 -198.832,-34.643 -199.818,-34.768C-200.928,-34.889 -202.162,-33.687 -203.517,-31.161C-204.875,-28.633 -206.23,-25.614 -207.585,-22.1C-208.943,-18.586 -210.238,-14.887 -211.469,-11.003C-212.7,-7.12 -213.687,-3.884 -214.428,-1.294C-215.043,0.925 -215.381,3.084 -215.444,5.178C-215.506,7.276 -215.229,9.155 -214.612,10.819C-213.994,12.483 -213.009,13.839 -211.653,14.887C-210.299,15.933 -208.573,16.46 -206.476,16.46C-204.996,16.581 -203.087,15.688 -200.742,13.778C-198.402,11.868 -195.842,9.431 -193.068,6.472C-190.294,3.513 -187.491,0.309 -184.653,-3.144C-181.818,-6.594 -179.262,-9.862 -176.979,-12.945C-176.62,-13.429 -176.287,-13.881 -175.948,-14.342C-176.791,-11.559 -177.575,-8.835 -178.274,-6.195C-179.078,-3.173 -179.661,-0.8 -180.031,0.925C-181.018,5.488 -181.109,9.218 -180.31,12.113C-179.505,15.009 -177.382,16.335 -173.929,16.09C-172.203,15.966 -170.386,15.101 -168.473,13.501C-166.563,11.899 -164.653,9.894 -162.74,7.49C-160.83,5.086 -158.948,2.529 -157.1,-0.185C-155.251,-2.895 -153.493,-5.424 -151.829,-7.767C-150.164,-10.108 -148.624,-12.05 -147.205,-13.593C-145.79,-15.133 -144.524,-15.965 -143.414,-16.089C-142.923,-16.089 -142.706,-15.442 -142.767,-14.148C-142.831,-12.853 -142.923,-11.249 -143.044,-9.339C-143.168,-7.426 -143.229,-5.331 -143.229,-3.051C-143.229,-0.769 -142.952,1.358 -142.397,3.329C-141.842,5.302 -140.981,6.999 -139.808,8.415C-138.638,9.834 -136.881,10.605 -134.537,10.726C-132.196,10.975 -129.637,10.296 -126.862,8.692C-124.088,7.092 -121.285,5.025 -118.448,2.497C-115.701,0.05 -113.012,-2.666 -110.38,-5.638C-110.423,-5.177 -110.477,-4.717 -110.496,-4.253C-110.617,-1.294 -109.94,1.479 -108.462,4.068C-106.981,6.658 -104.207,8.447 -100.139,9.431C-97.551,10.051 -94.9,10.079 -92.187,9.524C-89.477,8.969 -86.764,8.045 -84.05,6.751C-81.339,5.456 -78.687,3.855 -76.098,1.942C-73.509,0.032 -71.044,-1.97 -68.7,-4.069C-65.42,-7.05 -62.162,-10.354 -58.927,-13.968C-59.445,-11.896 -59.932,-9.77 -60.381,-7.582C-61.245,-3.389 -61.829,0.463 -62.138,3.976C-62.443,7.49 -62.352,10.388 -61.86,12.669C-61.369,14.948 -60.381,16.15 -58.901,16.274C-56.806,16.396 -54.647,15.041 -52.429,12.206C-50.209,9.372 -47.744,6.103 -45.031,2.404C-43.182,-0.185 -41.425,-2.681 -39.76,-5.085C-38.096,-7.49 -36.556,-9.616 -35.137,-11.466C-33.721,-13.315 -32.487,-14.795 -31.438,-15.904C-30.393,-17.014 -29.561,-17.505 -28.942,-17.384C-27.832,-17.135 -26.971,-16.612 -26.353,-15.812C-25.737,-15.009 -25.09,-14.176 -24.411,-13.315C-23.734,-12.451 -22.87,-11.743 -21.822,-11.189C-20.775,-10.634 -19.325,-10.478 -17.476,-10.726C-15.626,-10.972 -13.685,-11.651 -11.65,-12.761C-9.615,-13.87 -7.737,-15.133 -6.01,-16.552C-4.285,-17.968 -2.837,-19.418 -1.663,-20.897C-0.493,-22.377 0.154,-23.608 0.278,-24.596C0.523,-26.076 0.432,-27.122 0,-27.74",
    style: {
      fillRule: 'nonzero'
    }
  })))));
};

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles$o = {"icon":"storyliner-5QxXPHVz"};

var RemixIcon = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(RemixIcon, _React$PureComponent);

  function RemixIcon() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = RemixIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        customClasses = _this$props.customClasses,
        iconName = _this$props.iconName;
    return React.createElement("svg", {
      className: cn('remix', styles$o['icon'], customClasses)
    }, React.createElement("use", {
      xlinkHref: "/fonts/remixicon.symbol.svg#" + iconName
    }));
  };

  return RemixIcon;
}(React.PureComponent);

RemixIcon.defaultProps = {
  customClasses: ''
};
RemixIcon.propTypes = {
  customClasses: PropTypes.string,
  iconName: PropTypes.string.isRequired
};

var styles$n = {"button":"storyliner-T-qXWiOH","buttonIsDark":"storyliner-JYgF9pXo","buttonIsLight":"storyliner-Ud8szmgw","buttonIsUltraLight":"storyliner-FWgfgO7R","buttonIsNaked":"storyliner-8q3oYlic","buttonHasPrimaryText":"storyliner-ywg4pk6a","buttonHasWhiteText":"storyliner-c5ofr1vp","buttonIsExtraSmall":"storyliner-re9HjDyM","buttonExtraSmallIsRound":"storyliner-si6fzwT9","buttonIsSmall":"storyliner-0Zwa55Us","buttonSmallIsRound":"storyliner-3939KuaM","buttonIsMedium":"storyliner-R0kCPpV9","buttonMediumIsRound":"storyliner-rT2k73p7","buttonIsLarge":"storyliner--yP4ucHM","buttonLargeIsRound":"storyliner-7BUxb21U","iconIsExtraSmall":"storyliner--6UGYcMc","iconIsSmall":"storyliner-OgpRh-kf","iconIsMedium":"storyliner-Hb4EnAap","iconIsLarge":"storyliner-LjfpDTuL","spinner":"storyliner-23X6DUYp","spin":"storyliner-jJz0THCd","text":"storyliner-cy5QeAPh","textHasIcon":"storyliner-V4O7Th8L","textHasIconRight":"storyliner-GrnXxL-d"};

/* eslint-disable @typescript-eslint/no-explicit-any */
var ButtonColorEnum;

(function (ButtonColorEnum) {
  ButtonColorEnum["dark"] = "dark";
  ButtonColorEnum["light"] = "light";
  ButtonColorEnum["ultraLight"] = "ultraLight";
  ButtonColorEnum["naked"] = "naked";
})(ButtonColorEnum || (ButtonColorEnum = {}));

var ButtonSizeEnum;

(function (ButtonSizeEnum) {
  ButtonSizeEnum["extraSmall"] = "extraSmall";
  ButtonSizeEnum["small"] = "small";
  ButtonSizeEnum["medium"] = "medium";
  ButtonSizeEnum["large"] = "large";
})(ButtonSizeEnum || (ButtonSizeEnum = {}));

var ButtonTypeEnum;

(function (ButtonTypeEnum) {
  ButtonTypeEnum["button"] = "button";
  ButtonTypeEnum["reset"] = "reset";
  ButtonTypeEnum["submit"] = "submit";
})(ButtonTypeEnum || (ButtonTypeEnum = {})); // declare React component


var RawButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var buttonId = _ref.buttonId,
      color = _ref.color,
      formId = _ref.formId,
      customClasses = _ref.customClasses,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isRound = _ref.isRound,
      onClick = _ref.onClick,
      onKeyPress = _ref.onKeyPress,
      size = _ref.size,
      text = _ref.text,
      textIsPrimary = _ref.textIsPrimary,
      textIsWhite = _ref.textIsWhite,
      type = _ref.type;
  // init render
  var buttonStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$n['button'], 'mark-in-button', (_cn = {}, _cn[styles$n['buttonIsDark']] = color === 'dark', _cn[styles$n['buttonIsLight']] = color === 'light', _cn[styles$n['buttonIsUltraLight']] = color === 'ultraLight', _cn[styles$n['buttonIsNaked']] = color === 'naked', _cn[styles$n['buttonHasPrimaryText']] = textIsPrimary, _cn[styles$n['buttonHasWhiteText']] = textIsWhite, _cn[styles$n['buttonIsExtraSmall']] = size === 'extraSmall', _cn[styles$n['buttonIsSmall']] = size === 'small', _cn[styles$n['buttonIsMedium']] = size === 'medium', _cn[styles$n['buttonIsLarge']] = size === 'large', _cn[styles$n['buttonExtraSmallIsRound']] = isRound && size === 'extraSmall', _cn[styles$n['buttonSmallIsRound']] = isRound && size === 'small', _cn[styles$n['buttonMediumIsRound']] = isRound && size === 'medium', _cn[styles$n['buttonLargeIsRound']] = isRound && size === 'large', _cn), customClasses);
  }, [color, customClasses, isRound, size, textIsWhite, textIsPrimary]);
  var textStyles = React.useMemo(function () {
    var _cn2;

    return cn(styles$n['text'], (_cn2 = {}, _cn2[styles$n['textHasIcon']] = !!icon, _cn2[styles$n['textHasIconRight']] = !!iconRight, _cn2));
  }, [icon, iconRight]);
  var iconStyles = React.useMemo(function () {
    var _cn3;

    return cn((_cn3 = {}, _cn3[styles$n['iconIsExtraSmall']] = size === 'extraSmall', _cn3[styles$n['iconIsSmall']] = size === 'small', _cn3[styles$n['iconIsMedium']] = size === 'medium', _cn3[styles$n['iconIsLarge']] = size === 'large', _cn3));
  }, [size]); // init render

  return React.createElement("button", {
    className: buttonStyles,
    disabled: isDisabled,
    form: formId,
    id: buttonId,
    onClick: onClick,
    onKeyPress: onKeyPress,
    ref: ref,
    type: type
  }, isLoading && React.createElement("span", {
    className: styles$n['spinner']
  }, React.createElement(RemixIcon, {
    customClasses: iconStyles,
    iconName: "ri-loader-2-line"
  })), icon && React.createElement(RemixIcon, {
    customClasses: iconStyles,
    iconName: icon
  }), text && React.createElement("span", {
    className: textStyles,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), iconRight && React.createElement(RemixIcon, {
    customClasses: iconStyles,
    iconName: iconRight
  }));
});
RawButton.defaultProps = {
  buttonId: undefined,
  customClasses: undefined,
  formId: undefined,
  icon: undefined,
  iconRight: undefined,
  isDisabled: false,
  isLoading: false,
  isRound: false,
  onClick: function onClick() {
    return null;
  },
  onKeyPress: function onKeyPress() {
    return null;
  },
  size: 'medium',
  text: undefined,
  textIsPrimary: false,
  textIsWhite: false,
  type: 'button'
};
RawButton.propTypes = {
  buttonId: PropTypes.string,
  color: PropTypes.oneOf( /*#__PURE__*/Object.values(ButtonColorEnum)).isRequired,
  customClasses: PropTypes.string,
  formId: PropTypes.string,
  icon: PropTypes.string,
  iconRight: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isRound: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  size: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(ButtonSizeEnum)),
  text: PropTypes.string,
  textIsPrimary: PropTypes.bool,
  textIsWhite: PropTypes.bool,
  type: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(ButtonTypeEnum))
};
RawButton.displayName = 'Button';
var Button = /*#__PURE__*/React.memo(RawButton);

/* eslint-disable no-shadow */
var LocaleEnum;

(function (LocaleEnum) {
  LocaleEnum["EN"] = "en";
  LocaleEnum["DE"] = "de";
})(LocaleEnum || (LocaleEnum = {}));

var classNames$5 = {"container":"storyliner-JFDIcu66"};

/* eslint-disable react/jsx-no-useless-fragment */

var StorylinerPortal = function StorylinerPortal(_ref) {
  var _document, _document2;

  var children = _ref.children;
  // prevent portal during ssr
  if (typeof document === 'undefined') return React.createElement(React.Fragment, null, children); // get portal element

  var toolbars = (_document = document) == null ? void 0 : _document.getElementById('storyliner-portals');
  var container = toolbars || ((_document2 = document) == null ? void 0 : _document2.body); // build portal

  return ReactDOM.createPortal(children, container);
};

/* eslint-disable @typescript-eslint/no-explicit-any */
// type export not necessary, since Placement comes from popperjs
// https://atomiks.github.io/tippyjs/v6/all-props/#placement

var DropdownPlacementEnum;

(function (DropdownPlacementEnum) {
  // default
  DropdownPlacementEnum["top"] = "top"; // full list:

  DropdownPlacementEnum["top-start"] = "top-start";
  DropdownPlacementEnum["top-end"] = "top-end";
  DropdownPlacementEnum["right"] = "right";
  DropdownPlacementEnum["right-start"] = "right-start";
  DropdownPlacementEnum["right-end"] = "right-end";
  DropdownPlacementEnum["bottom"] = "bottom";
  DropdownPlacementEnum["bottom-start"] = "bottom-start";
  DropdownPlacementEnum["bottom-end"] = "bottom-end";
  DropdownPlacementEnum["left"] = "left";
  DropdownPlacementEnum["left-start"] = "left-start";
  DropdownPlacementEnum["left-end"] = "left-end"; // choose the side with most space

  DropdownPlacementEnum["auto"] = "auto";
  DropdownPlacementEnum["auto-start"] = "auto-start";
  DropdownPlacementEnum["auto-end"] = "auto-end";
})(DropdownPlacementEnum || (DropdownPlacementEnum = {})); // Dropdown component


var Dropdown = /*#__PURE__*/React.forwardRef(function (_ref, referenceElement) {
  var children = _ref.children,
      hideDropdown = _ref.hideDropdown,
      isActive = _ref.isActive,
      placement = _ref.placement;

  // init refs
  var _useImmer = useImmer(null),
      popperElement = _useImmer[0],
      setPopperElement = _useImmer[1]; // init hooks


  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'preventOverflow',
      options: {
        padding: 8
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 8]
      }
    }]
  }),
      attributes = _usePopper.attributes,
      styles = _usePopper.styles,
      update = _usePopper.update; // close toolbar on outside click


  var onOutsideClick = React.useCallback(function (event) {
    // when button is clicked
    if (referenceElement != null && referenceElement.contains(event.target)) {
      return;
    } // close on outside click


    if (popperElement && !(popperElement != null && popperElement.contains(event.target))) {
      hideDropdown();
    } // close on right mouse click


    if ((event == null ? void 0 : event.button) === 2) {
      hideDropdown();
    }
  }, [hideDropdown, popperElement, referenceElement]); // handle data changes

  React.useEffect(function () {
    // add event listener
    document.addEventListener('mousedown', onOutsideClick, false);
    document.addEventListener('touchstart', onOutsideClick, false); // remove event listener

    return function () {
      document.removeEventListener('mousedown', onOutsideClick, false);
      document.removeEventListener('touchstart', onOutsideClick, false);
    };
  }, [onOutsideClick]);
  React.useEffect(function () {
    if (isActive) {
      if (update) {
        update();
      }
    }
  }, [isActive, update]); // init render

  return React.createElement(StorylinerPortal, null, React.createElement("div", Object.assign({
    className: classNames$5['container'],
    ref: setPopperElement,
    style: styles['popper']
  }, attributes['popper']), children));
});
Dropdown.defaultProps = {
  placement: 'bottom'
};
Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  hideDropdown: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  placement: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(DropdownPlacementEnum))
};
Dropdown.displayName = 'Dropdown';

var classNames$4 = {"container":"storyliner--xz5t4Yi","helptext":"storyliner-Pm8SXjvT","text":"storyliner-pDf4A2oR","textIsActive":"storyliner-y5-kFCaE","textIsSmall":"storyliner-YMQEvWxg","textIsDanger":"storyliner-TgMlPVzO","icon":"storyliner--Kkfi0RF","iconIsActive":"storyliner-pRbXfsHQ","iconIsHidden":"storyliner-XQdxHY-E","iconIsDanger":"storyliner-k21fmakf","iconIsSmall":"storyliner-8YXQOPG5","image":"storyliner-Lzm0G05s","imageIsRound":"storyliner-t1LBnmq4","button":"storyliner-WZQP7jQK","buttonIsSmall":"storyliner-LxassG5t","buttonIsSelected":"storyliner-WQnYdtls"};

/* eslint-disable @typescript-eslint/no-explicit-any */

var DropdownItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var handleClick = _ref.handleClick,
      helpText = _ref.helpText,
      icon = _ref.icon,
      iconIsHidden = _ref.iconIsHidden,
      image = _ref.image,
      imageIsRound = _ref.imageIsRound,
      isActive = _ref.isActive,
      isDanger = _ref.isDanger,
      isDisabled = _ref.isDisabled,
      isSelected = _ref.isSelected,
      isSmall = _ref.isSmall,
      text = _ref.text;
  // init styles
  var buttonStyles = React.useMemo(function () {
    var _cn;

    return cn(classNames$4['button'], (_cn = {}, _cn[classNames$4['buttonIsSmall']] = isSmall, _cn[classNames$4['buttonIsSelected']] = isSelected, _cn));
  }, [isSmall, isSelected]);
  var iconStyles = React.useMemo(function () {
    var _cn2;

    return cn(classNames$4['icon'], (_cn2 = {}, _cn2[classNames$4['iconIsHidden']] = iconIsHidden, _cn2[classNames$4['iconIsActive']] = isActive, _cn2[classNames$4['iconIsSmall']] = isSmall, _cn2[classNames$4['iconIsDanger']] = isDanger, _cn2));
  }, [iconIsHidden, isDanger, isActive, isSmall]);
  var textStyles = React.useMemo(function () {
    var _cn3;

    return cn(classNames$4['text'], (_cn3 = {}, _cn3[classNames$4['textIsActive']] = isActive, _cn3[classNames$4['textIsSmall']] = isSmall, _cn3[classNames$4['textIsDanger']] = isDanger, _cn3));
  }, [isDanger, isActive, isSmall]);
  var imageStyles = React.useMemo(function () {
    var _cn4;

    return cn(classNames$4['image'], (_cn4 = {}, _cn4[classNames$4['imageIsRound']] = imageIsRound, _cn4));
  }, [imageIsRound]); // render

  return React.createElement("div", {
    className: classNames$4['container']
  }, React.createElement("button", {
    className: buttonStyles,
    disabled: isDisabled,
    onClick: handleClick,
    ref: ref,
    type: "button"
  }, icon && React.createElement("div", {
    className: iconStyles
  }, React.createElement(RemixIcon, {
    iconName: icon
  })), image && React.createElement("div", {
    className: imageStyles
  }, React.createElement("img", {
    alt: text,
    src: image,
    title: text
  })), React.createElement("div", {
    className: textStyles,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), helpText && React.createElement("div", {
    className: classNames$4['helptext'],
    dangerouslySetInnerHTML: {
      __html: helpText
    }
  })));
});
DropdownItem.defaultProps = {
  handleClick: function handleClick() {
    return null;
  },
  helpText: null,
  icon: null,
  iconIsHidden: false,
  image: null,
  imageIsRound: false,
  isActive: false,
  isDanger: false,
  isDisabled: false,
  isSelected: false,
  isSmall: false
};
DropdownItem.propTypes = {
  handleClick: PropTypes.func,
  helpText: PropTypes.string,
  icon: PropTypes.string,
  iconIsHidden: PropTypes.bool,
  image: PropTypes.string,
  imageIsRound: PropTypes.bool,
  isActive: PropTypes.bool,
  isDanger: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSmall: PropTypes.bool,
  text: PropTypes.string.isRequired
};
DropdownItem.displayName = 'DropdownItem';

var styles$m = {"container":"storyliner-oCj5-O9H","fade-in-up":"storyliner-S0XJpd8P","isActive":"storyliner-Ls94fotB"};

// import node_modules

var DropdownMenu = function DropdownMenu(_ref) {
  var children = _ref.children,
      customClasses = _ref.customClasses,
      isActive = _ref.isActive;
  // init classes
  var menuStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$m['container'], (_cn = {}, _cn[styles$m['isActive']] = isActive, _cn), customClasses);
  }, [customClasses, isActive]); // render

  return React.createElement("div", {
    className: menuStyles
  }, children);
};

DropdownMenu.defaultProps = {
  customClasses: undefined
};
DropdownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  customClasses: PropTypes.string
};
DropdownMenu.displayName = 'DropdownMenu';

/* eslint-disable @typescript-eslint/ban-ts-comment */

var content$1 = {
  en: {
    languages: [{
      code: LocaleEnum.DE,
      label: 'Deutsch'
    }, {
      code: LocaleEnum.EN,
      label: 'English'
    }]
  },
  de: {
    languages: [{
      code: LocaleEnum.DE,
      label: 'Deutsch'
    }, {
      code: LocaleEnum.EN,
      label: 'English'
    }]
  }
}; // define components

var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var _t$languages, _t$languages$find;

  var changeLocale = _ref.changeLocale,
      locale = _ref.locale,
      isSmall = _ref.isSmall;
  // init vars
  var t = React.useMemo(function () {
    return content$1[locale || 'en'];
  }, [locale]); // init states

  var _useImmer = useImmer(false),
      dropdownState = _useImmer[0],
      setDropdownState = _useImmer[1];

  var _useImmer2 = useImmer(null),
      referenceElement = _useImmer2[0],
      setReferenceElement = _useImmer2[1]; // init func


  var onToggleDropdown = React.useCallback(function () {
    setDropdownState(!dropdownState);
  }, [dropdownState, setDropdownState]);
  var onHideDropdown = React.useCallback(function () {
    setDropdownState(false);
  }, [setDropdownState]); // init render

  var currentLangLabel = (_t$languages = t.languages) == null ? void 0 : (_t$languages$find = _t$languages.find(function (item) {
    return item.code === locale;
  })) == null ? void 0 : _t$languages$find.label;
  return React.createElement(React.Fragment, null, React.createElement(Button, {
    color: "ultraLight",
    icon: "ri-global-line",
    onClick: onToggleDropdown,
    ref: setReferenceElement,
    size: isSmall ? 'extraSmall' : 'small',
    text: currentLangLabel
  }), React.createElement("div", {
    className: "storyliner-language-switcher-menu"
  }, React.createElement(Dropdown, {
    hideDropdown: onHideDropdown,
    isActive: dropdownState,
    placement: "top",
    ref: referenceElement
  }, React.createElement(DropdownMenu, {
    isActive: dropdownState
  }, t.languages.map(function (item) {
    return React.createElement(DropdownItem, {
      handleClick: function handleClick() {
        return changeLocale(item.code);
      },
      isActive: item.code === locale,
      key: item.code,
      text: item.label
    });
  })))));
};

LanguageSwitcher.defaultProps = {
  isSmall: false
};
LanguageSwitcher.propTypes = {
  changeLocale: PropTypes.func.isRequired,
  isSmall: PropTypes.bool,
  locale: PropTypes.oneOf( /*#__PURE__*/Object.values(LocaleEnum)).isRequired
};

/* eslint-disable react/no-danger */

var LinkButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
      customClasses = _ref.customClasses,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      isRound = _ref.isRound,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      size = _ref.size,
      tabIndex = _ref.tabIndex,
      text = _ref.text,
      textIsPrimary = _ref.textIsPrimary,
      textIsWhite = _ref.textIsWhite;
  // init render
  var buttonStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$n['button'], 'mark-in-button', (_cn = {}, _cn[styles$n['buttonIsDark']] = color === 'dark', _cn[styles$n['buttonIsLight']] = color === 'light', _cn[styles$n['buttonIsUltraLight']] = color === 'ultraLight', _cn[styles$n['buttonIsNaked']] = color === 'naked', _cn[styles$n['buttonHasPrimaryText']] = textIsPrimary, _cn[styles$n['buttonHasWhiteText']] = textIsWhite, _cn[styles$n['buttonIsExtraSmall']] = size === 'extraSmall', _cn[styles$n['buttonIsSmall']] = size === 'small', _cn[styles$n['buttonIsMedium']] = size === 'medium', _cn[styles$n['buttonIsLarge']] = size === 'large', _cn[styles$n['buttonExtraSmallIsRound']] = isRound && size === 'extraSmall', _cn[styles$n['buttonSmallIsRound']] = isRound && size === 'small', _cn[styles$n['buttonMediumIsRound']] = isRound && size === 'medium', _cn[styles$n['buttonLargeIsRound']] = isRound && size === 'large', _cn), customClasses);
  }, [color, customClasses, isRound, size, textIsWhite, textIsPrimary]);
  var textStyles = React.useMemo(function () {
    var _cn2;

    return cn(styles$n['text'], (_cn2 = {}, _cn2[styles$n['textHasIcon']] = !!icon, _cn2[styles$n['textHasIconRight']] = !!iconRight, _cn2));
  }, [icon, iconRight]);
  var iconStyles = React.useMemo(function () {
    var _cn3;

    return cn((_cn3 = {}, _cn3[styles$n['iconIsExtraSmall']] = size === 'extraSmall', _cn3[styles$n['iconIsSmall']] = size === 'small', _cn3[styles$n['iconIsMedium']] = size === 'medium', _cn3[styles$n['iconIsLarge']] = size === 'large', _cn3));
  }, [size]); // render

  return React.createElement("div", {
    className: buttonStyles,
    onClick: onClick,
    onKeyDown: onKeyDown,
    ref: ref,
    role: "button",
    tabIndex: tabIndex
  }, icon && React.createElement(RemixIcon, {
    customClasses: iconStyles,
    iconName: icon
  }), text && React.createElement("span", {
    className: textStyles,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), iconRight && React.createElement(RemixIcon, {
    customClasses: iconStyles,
    iconName: iconRight
  }));
});
LinkButton.defaultProps = {
  customClasses: undefined,
  icon: undefined,
  iconRight: undefined,
  isRound: false,
  onClick: function onClick() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  size: 'medium',
  tabIndex: -1,
  text: undefined,
  textIsPrimary: false,
  textIsWhite: false
};
LinkButton.propTypes = {
  color: PropTypes.oneOf( /*#__PURE__*/Object.values(ButtonColorEnum)).isRequired,
  customClasses: PropTypes.string,
  icon: PropTypes.string,
  iconRight: PropTypes.string,
  isRound: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  size: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(ButtonSizeEnum)),
  tabIndex: PropTypes.number,
  text: PropTypes.string,
  textIsPrimary: PropTypes.bool,
  textIsWhite: PropTypes.bool
};
LinkButton.displayName = 'LinkButton';

var styles$l = {"container":"storyliner-BvL6b7nO","card":"storyliner-a3yuB3RK"};

// import node_modules

var Card = function Card(_ref) {
  var children = _ref.children,
      customClasses = _ref.customClasses,
      zIndex = _ref.zIndex;
  return React.createElement("div", {
    className: cn(styles$l['container'], customClasses),
    style: {
      zIndex: zIndex
    }
  }, React.createElement("div", {
    className: styles$l['card']
  }, children));
};

Card.defaultProps = {
  customClasses: undefined,
  zIndex: 1
};
Card.propTypes = {
  children: PropTypes.node.isRequired,
  customClasses: PropTypes.string,
  zIndex: PropTypes.number
};
Card.displayName = 'Card';

var styles$k = {"heading":"storyliner-0Xlajakw","headingIsLeft":"storyliner-SeOWroUh","headingIsCenter":"storyliner-2MJfHcjB","headingIsRight":"storyliner-Ya4X21pZ","headingDefaultColor":"storyliner-yRNhQlj2","headingIsWhite":"storyliner-7-klaBUu","heading1":"storyliner-P8pbCd6w","heading2":"storyliner-jClES3eK","heading3":"storyliner-nmFYHyBf","heading4":"storyliner-naXXFHdM","heading5":"storyliner-IHI3G86u","heading6":"storyliner-HBu9IQmC","headingIsLabel":"storyliner-dnVWe0-z"};

/* eslint-disable react/no-danger */
var HeadingTagEnum;

(function (HeadingTagEnum) {
  HeadingTagEnum["h1"] = "h1";
  HeadingTagEnum["h2"] = "h2";
  HeadingTagEnum["h3"] = "h3";
  HeadingTagEnum["h4"] = "h4";
  HeadingTagEnum["h5"] = "h5";
  HeadingTagEnum["h6"] = "h6";
  HeadingTagEnum["label"] = "label";
})(HeadingTagEnum || (HeadingTagEnum = {}));

var HeadingAlignmentEnum;

(function (HeadingAlignmentEnum) {
  HeadingAlignmentEnum["left"] = "left";
  HeadingAlignmentEnum["center"] = "center";
  HeadingAlignmentEnum["right"] = "right";
})(HeadingAlignmentEnum || (HeadingAlignmentEnum = {})); // Heading component


var Heading = function Heading(_ref) {
  var alignment = _ref.alignment,
      customClasses = _ref.customClasses,
      children = _ref.children,
      isHyphenated = _ref.isHyphenated,
      isWhite = _ref.isWhite,
      tag = _ref.tag;
  // init render
  var headingStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$k['heading'], (_cn = {}, _cn[styles$k['headingIsLeft']] = alignment === 'left', _cn[styles$k['headingIsCenter']] = alignment === 'center', _cn[styles$k['headingIsRight']] = alignment === 'right', _cn[styles$k['headingIsWhite']] = isWhite, _cn[styles$k['headingDefaultColor']] = !isWhite && tag !== 'label', _cn['is-hyphenated'] = isHyphenated, _cn[styles$k['heading1']] = tag === 'h1', _cn[styles$k['heading2']] = tag === 'h2', _cn[styles$k['heading3']] = tag === 'h3', _cn[styles$k['heading4']] = tag === 'h4', _cn[styles$k['heading5']] = tag === 'h5', _cn[styles$k['heading6']] = tag === 'h6', _cn[styles$k['headingIsLabel']] = tag === 'label', _cn), customClasses);
  }, [alignment, customClasses, isHyphenated, isWhite, tag]);
  return React.createElement(React.Fragment, null, tag === HeadingTagEnum.h1 && React.createElement("h1", {
    className: headingStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }), tag === HeadingTagEnum.h2 && React.createElement("h2", {
    className: headingStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }), tag === HeadingTagEnum.h3 && React.createElement("h3", {
    className: headingStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }), tag === HeadingTagEnum.h4 && React.createElement("h4", {
    className: headingStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }), tag === HeadingTagEnum.h5 && React.createElement("h5", {
    className: headingStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }), tag === HeadingTagEnum.h6 && React.createElement("h6", {
    className: headingStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }), tag === HeadingTagEnum.label && React.createElement("div", {
    className: headingStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
};

Heading.defaultProps = {
  alignment: 'left',
  customClasses: undefined,
  isHyphenated: true,
  isWhite: false,
  tag: 'h1'
};
Heading.propTypes = {
  alignment: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(HeadingAlignmentEnum)),
  children: PropTypes.string.isRequired,
  customClasses: PropTypes.string,
  isHyphenated: PropTypes.bool,
  isWhite: PropTypes.bool,
  tag: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(HeadingTagEnum))
};
Heading.displayName = 'Heading';

var styles$j = {"text":"storyliner-NvkaqB4W","textIsSmall":"storyliner-JKbDd--N","textIsNormal":"storyliner-56rVGydt","textIsLarge":"storyliner-3E--dM-J","textIsLeft":"storyliner-FB20GetH","textIsCenter":"storyliner-2DeJMGWk","textIsRight":"storyliner-eB86mFAk","textDefaultColor":"storyliner-dCLDrdhp","textIsError":"storyliner-116AqtQY","textIsWhite":"storyliner-3QOnLQCX","textIsHelpText":"storyliner-Ypxb-JT8","textIsItalic":"storyliner-Rw5IIBzB"};

/* eslint-disable react/no-danger */
var TextSizeEnum;

(function (TextSizeEnum) {
  TextSizeEnum["large"] = "large";
  TextSizeEnum["normal"] = "normal";
  TextSizeEnum["small"] = "small";
})(TextSizeEnum || (TextSizeEnum = {}));

var TextAlignmentEnum;

(function (TextAlignmentEnum) {
  TextAlignmentEnum["left"] = "left";
  TextAlignmentEnum["center"] = "center";
  TextAlignmentEnum["right"] = "right";
})(TextAlignmentEnum || (TextAlignmentEnum = {})); // Text component


var Text = function Text(_ref) {
  var alignment = _ref.alignment,
      customClasses = _ref.customClasses,
      children = _ref.children,
      isError = _ref.isError,
      isHelpText = _ref.isHelpText,
      isItalic = _ref.isItalic,
      isWhite = _ref.isWhite,
      size = _ref.size;
  // init render
  var textStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$j['text'], 'inner-link', (_cn = {}, _cn[styles$j['textIsSmall']] = size === 'small', _cn[styles$j['textIsNormal']] = size === 'normal', _cn[styles$j['textIsLarge']] = size === 'large', _cn[styles$j['textIsLeft']] = alignment === 'left', _cn[styles$j['textIsCenter']] = alignment === 'center', _cn[styles$j['textIsRight']] = alignment === 'right', _cn[styles$j['textIsError']] = isError, _cn[styles$j['textIsWhite']] = isWhite, _cn[styles$j['textIsHelpText']] = isHelpText, _cn[styles$j['textDefaultColor']] = !isError && !isWhite && !isHelpText, _cn[styles$j['textIsItalic']] = isItalic, _cn), customClasses);
  }, [alignment, customClasses, isError, isHelpText, isItalic, isWhite, size]);
  return React.createElement("div", {
    className: textStyles,
    dangerouslySetInnerHTML: {
      __html: children
    }
  });
};

Text.defaultProps = {
  alignment: 'left',
  customClasses: undefined,
  isError: false,
  isHelpText: false,
  isItalic: false,
  isWhite: false,
  size: 'normal'
};
Text.propTypes = {
  alignment: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(TextAlignmentEnum)),
  children: PropTypes.string.isRequired,
  customClasses: PropTypes.string,
  isError: PropTypes.bool,
  isHelpText: PropTypes.bool,
  isItalic: PropTypes.bool,
  isWhite: PropTypes.bool,
  size: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(TextSizeEnum))
};
Text.displayName = 'Text';

// import node_modules

var useMeasure = function useMeasure() {
  // init states
  var _useImmer = useImmer({
    left: 0,
    top: 0,
    width: 0,
    height: 0
  }),
      bounds = _useImmer[0],
      set = _useImmer[1];

  var _useImmer2 = useImmer(function () {
    return new ResizeObserver(function (_ref) {
      var entry = _ref[0];
      return set(entry.contentRect);
    });
  }),
      ro = _useImmer2[0]; // init refs


  var ref = React.useRef(); // handle data changes

  React.useEffect(function () {
    if (ref.current) ro.observe(ref.current);
    return function () {
      return ro.disconnect();
    };
  }, [ro]); // return

  return [{
    ref: ref
  }, bounds];
};

var styles$i = {"innerBox":"storyliner-fg0WMOm-","infoText":"storyliner-3hrqRi-z","title":"storyliner-ZFsc58j2","infobox":"storyliner-et8p4unU","fade-in":"storyliner-dG64-3pY","container":"storyliner-sdaEkTWX"};

// import node_modules

var InfoBox = function InfoBox(_ref) {
  var description = _ref.description,
      innerBox = _ref.innerBox,
      title = _ref.title,
      toggleFunc = _ref.toggleFunc;

  // init hooks
  var _useMeasure = useMeasure(),
      ref = _useMeasure[0].ref,
      viewHeight = _useMeasure[1].height; // init render


  return React.createElement("div", {
    className: styles$i['container'],
    style: {
      height: toggleFunc ? viewHeight + "px" : 'auto'
    }
  }, React.createElement("div", {
    className: styles$i['infobox'],
    ref: ref
  }, React.createElement("div", {
    className: styles$i['title']
  }, React.createElement(Heading, {
    tag: "h6"
  }, title), toggleFunc && React.createElement(Button, {
    color: "naked",
    icon: "ri-close-line",
    onClick: toggleFunc,
    size: "small"
  })), React.createElement("div", {
    className: styles$i['infoText']
  }, React.createElement(Text, null, description)), innerBox && React.createElement("div", {
    className: styles$i['innerBox']
  }, innerBox)));
};

InfoBox.defaultProps = {
  innerBox: undefined,
  toggleFunc: undefined
};
InfoBox.propTypes = {
  description: PropTypes.string.isRequired,
  innerBox: PropTypes.node,
  title: PropTypes.string.isRequired,
  toggleFunc: PropTypes.func
};

var classNames$3 = {"tooltip":"storyliner-HW90e186","contentContainer":"storyliner-TUycLx60","fade-in":"storyliner-lxN-Ajoq","content":"storyliner-bBRn-Uh8"};

/* eslint-disable no-param-reassign */
// type export not necessary, since Placement comes from popperjs
// https://atomiks.github.io/tippyjs/v6/all-props/#placement

var TooltipPlacementEnum;

(function (TooltipPlacementEnum) {
  // default
  TooltipPlacementEnum["top"] = "top"; // full list:

  TooltipPlacementEnum["top-start"] = "top-start";
  TooltipPlacementEnum["top-end"] = "top-end";
  TooltipPlacementEnum["right"] = "right";
  TooltipPlacementEnum["right-start"] = "right-start";
  TooltipPlacementEnum["right-end"] = "right-end";
  TooltipPlacementEnum["bottom"] = "bottom";
  TooltipPlacementEnum["bottom-start"] = "bottom-start";
  TooltipPlacementEnum["bottom-end"] = "bottom-end";
  TooltipPlacementEnum["left"] = "left";
  TooltipPlacementEnum["left-start"] = "left-start";
  TooltipPlacementEnum["left-end"] = "left-end"; // choose the side with most space

  TooltipPlacementEnum["auto"] = "auto";
  TooltipPlacementEnum["auto-start"] = "auto-start";
  TooltipPlacementEnum["auto-end"] = "auto-end";
})(TooltipPlacementEnum || (TooltipPlacementEnum = {})); // Tooltip component


var Tooltip = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
      content = _ref.content,
      isDisabled = _ref.isDisabled,
      placement = _ref.placement;
  // init vars
  var popperOptions = React.useMemo(function () {
    return {
      placement: placement,
      strategy: 'fixed',
      modifiers: [{
        name: 'preventOverflow',
        options: {
          padding: 8
        }
      }, {
        name: 'offset',
        options: {
          offset: [0, 6]
        }
      }]
    };
  }, [placement]); // init states

  var _useImmer = useImmer({
    element: null
  }),
      referenceElement = _useImmer[0],
      setReferenceElement = _useImmer[1];

  var _useImmer2 = useImmer({
    element: null
  }),
      popperElement = _useImmer2[0],
      setPopperElement = _useImmer2[1];

  var _usePopper = usePopper(referenceElement == null ? void 0 : referenceElement.element, popperElement == null ? void 0 : popperElement.element, popperOptions),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update; // init func


  var onShow = React.useCallback(function () {
    // Make the tooltip visible
    if (popperElement != null && popperElement.element && !isDisabled) {
      var _popperElement$elemen;

      popperElement == null ? void 0 : (_popperElement$elemen = popperElement.element) == null ? void 0 : _popperElement$elemen.setAttribute('data-show', ''); // Update its position

      if (update) {
        update();
      }
    }
  }, [isDisabled, popperElement, update]);
  var onHide = React.useCallback(function () {
    // Hide the tooltip
    if (popperElement != null && popperElement.element) {
      var _popperElement$elemen2;

      popperElement == null ? void 0 : (_popperElement$elemen2 = popperElement.element) == null ? void 0 : _popperElement$elemen2.removeAttribute('data-show');
    }
  }, [popperElement]);
  var onSetPopperElement = React.useCallback(function (nextElement) {
    setPopperElement(function (draft) {
      draft.element = nextElement;
    });
  }, [setPopperElement]);
  var onSetReferenceElement = React.useCallback(function (nextElement) {
    setReferenceElement(function (draft) {
      draft.element = nextElement;
    });
  }, [setReferenceElement]); // handle data changes

  React.useEffect(function () {
    if (isDisabled) {
      onHide();
    }
  }, [isDisabled, onHide]);
  React.useEffect(function () {
    // https://popper.js.org/docs/v2/tutorial/#functionality
    var showEvents = ['mouseenter', 'focus', 'touchstart'];
    var hideEvents = ['mousedown', 'mouseleave', 'blur', 'touchend'];
    showEvents.forEach(function (event) {
      if (referenceElement != null && referenceElement.element) {
        var _referenceElement$ele;

        referenceElement == null ? void 0 : (_referenceElement$ele = referenceElement.element) == null ? void 0 : _referenceElement$ele.addEventListener(event, onShow);
      }
    });
    hideEvents.forEach(function (event) {
      if (referenceElement != null && referenceElement.element) {
        var _referenceElement$ele2;

        referenceElement == null ? void 0 : (_referenceElement$ele2 = referenceElement.element) == null ? void 0 : _referenceElement$ele2.addEventListener(event, onHide);
      }
    });
  }, [onShow, onHide, referenceElement]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classNames$3['tooltip'],
    contentEditable: false,
    ref: onSetReferenceElement
  }, children), React.createElement(StorylinerPortal, null, React.createElement("div", Object.assign({
    ref: onSetPopperElement,
    className: classNames$3['contentContainer'],
    contentEditable: false,
    style: styles['popper']
  }, attributes['popper']), React.createElement("div", {
    className: classNames$3['content'],
    dangerouslySetInnerHTML: {
      __html: content
    }
  }))));
});
Tooltip.defaultProps = {
  isDisabled: false
};
Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  placement: PropTypes.oneOf( /*#__PURE__*/Object.values(TooltipPlacementEnum)).isRequired
};
Tooltip.displayName = 'Tooltip';

var styles$h = {"tag":"storyliner-rXLSXwav","icon":"storyliner-ZdnRrNUv","tagIsDark":"storyliner-YmYmH5bC","tagIsLight":"storyliner-CL165kni","iconIsLeft":"storyliner-j9WcP8Mb","iconIsRight":"storyliner-pQp4aYRb","text":"storyliner-YpAamfQZ"};

// import node_modules
var TagColorEnum;

(function (TagColorEnum) {
  TagColorEnum["light"] = "light";
  TagColorEnum["dark"] = "dark";
})(TagColorEnum || (TagColorEnum = {})); // Tags component


var Tags = function Tags(_ref) {
  var color = _ref.color,
      icon = _ref.icon,
      removeFunc = _ref.removeFunc,
      removeText = _ref.removeText,
      tags = _ref.tags;
  // init func
  var onGetKey = React.useCallback(function (key, index) {
    return key + "-" + index;
  }, []); // init styles

  var tagStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$h['tag'], (_cn = {}, _cn[styles$h['tagIsDark']] = color === TagColorEnum.dark, _cn[styles$h['tagIsLight']] = color === TagColorEnum.light, _cn[styles$h['iconIsLeft']] = !!icon, _cn[styles$h['iconIsRight']] = !!removeFunc, _cn));
  }, [color, icon, removeFunc]); // render

  return React.createElement(React.Fragment, null, tags.map(function (tag, index) {
    return React.createElement("div", {
      key: onGetKey(tag, index),
      className: tagStyles
    }, icon && React.createElement("span", {
      className: styles$h['icon']
    }, React.createElement(RemixIcon, {
      iconName: icon
    })), React.createElement("span", {
      className: styles$h['text']
    }, tag), removeFunc && removeText && React.createElement(Tooltip, {
      content: removeText,
      placement: "top"
    }, React.createElement(Button, {
      color: "dark",
      icon: "ri-close-line",
      onClick: function onClick() {
        return removeFunc(index);
      },
      size: "extraSmall"
    })));
  }));
};

Tags.defaultProps = {
  color: TagColorEnum.light,
  icon: undefined,
  removeFunc: undefined,
  removeText: undefined
};
Tags.propTypes = {
  color: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(TagColorEnum)),
  icon: PropTypes.string,
  removeFunc: PropTypes.func,
  removeText: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};
Tags.displayName = 'Tags';

var styles$g = {"item":"storyliner--gWzAaId","itemIsSelected":"storyliner-osDSthlz","suggestions":"storyliner-8OEifU04","suggestionsScrollContainer":"storyliner-Ctvg1ZLU","suggestionsContainer":"storyliner-glbq9L5-","input":"storyliner-gNoLbJs-","inputLabel":"storyliner-lojbKq5J","inputLabelText":"storyliner-IWUBwojY","inputContainer":"storyliner-tE2C4PQ2","helptext":"storyliner-LSF8-3S0","autosuggest":"storyliner-pEZRyCOA"};

/* eslint-disable no-param-reassign */

var Autosuggest = function Autosuggest(_ref) {
  var createItem = _ref.createItem,
      customInputClasses = _ref.customInputClasses,
      customLabelClasses = _ref.customLabelClasses,
      helpText = _ref.helpText,
      inputId = _ref.inputId,
      isDisabled = _ref.isDisabled,
      labelText = _ref.labelText,
      placeholderText = _ref.placeholderText,
      resetInput = _ref.resetInput,
      selectItem = _ref.selectItem,
      storeInputValue = _ref.storeInputValue,
      suggestions = _ref.suggestions;

  // init state
  var _useImmer = useImmer(suggestions || []),
      suggestionsState = _useImmer[0],
      setSuggestionsState = _useImmer[1]; // init refs


  var suggestionsRef = React.useRef(); // init methods

  var onSelectItem = React.useCallback(function (selectedItem) {
    selectItem(selectedItem);
  }, [selectItem]); // handle data changes

  React.useEffect(function () {
    // track changes
    var prevSuggestions = suggestionsRef.current;
    var nextSuggestions = suggestions || [];

    if (prevSuggestions !== nextSuggestions) {
      suggestionsRef.current = nextSuggestions;
      setSuggestionsState(nextSuggestions);
    }
  }, [suggestions, setSuggestionsState]); // init downshift

  var _useCombobox = useCombobox({
    items: suggestionsState,
    onInputValueChange: function onInputValueChange(_ref2) {
      var currentInputValue = _ref2.inputValue;
      return setSuggestionsState(suggestions.filter(function (item) {
        var _item$toLowerCase;

        return (_item$toLowerCase = item.toLowerCase()) == null ? void 0 : _item$toLowerCase.includes(currentInputValue == null ? void 0 : currentInputValue.toLowerCase());
      }));
    },
    onSelectedItemChange: function onSelectedItemChange(_ref3) {
      var selectedItem = _ref3.selectedItem;

      // select item
      if (selectedItem) {
        onSelectItem(selectedItem);
      } // reset if creation is enabled


      if (createItem) {
        setInputValue('');
      }
    }
  }),
      getComboboxProps = _useCombobox.getComboboxProps,
      getInputProps = _useCombobox.getInputProps,
      getItemProps = _useCombobox.getItemProps,
      getLabelProps = _useCombobox.getLabelProps,
      getMenuProps = _useCombobox.getMenuProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      inputValue = _useCombobox.inputValue,
      isOpen = _useCombobox.isOpen,
      setInputValue = _useCombobox.setInputValue,
      closeMenu = _useCombobox.closeMenu; // reset input


  React.useEffect(function () {
    if (resetInput) {
      setInputValue('');
    }
  }, [resetInput, setInputValue]); // customize downshift

  var filteredItems = suggestions == null ? void 0 : suggestions.filter(function (suggestion) {
    return suggestion == null ? void 0 : suggestion.toLowerCase().includes((inputValue == null ? void 0 : inputValue.toLowerCase()) || '');
  });
  var itemFound = filteredItems.length !== 0;
  var inputProps = getInputProps({
    id: inputId,
    disabled: isDisabled,
    onChange: function onChange(event) {
      if (storeInputValue) {
        var _event$target;

        storeInputValue((event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) || '');
      }
    },
    onKeyDown: function onKeyDown(event) {
      // prevent other keydown events
      event.stopPropagation(); // handle item creation

      if (createItem) {
        if (event.key === 'Enter') {
          // Prevent Downshift's default 'Enter' behavior.
          event.nativeEvent.preventDownshiftDefault = true; // use highlighted suggestion if available

          if (suggestionsState[highlightedIndex]) {
            // your handler code
            onSelectItem(suggestionsState[highlightedIndex]);
          } else {
            var _event$target2;

            // your handler code
            onSelectItem((event == null ? void 0 : (_event$target2 = event.target) == null ? void 0 : _event$target2.value) || '');
          } // reset input


          closeMenu();
          setInputValue('');
        }
      }
    }
  }); // render

  return React.createElement("div", {
    className: styles$g['autosuggest']
  }, React.createElement("div", Object.assign({
    className: styles$g['inputContainer']
  }, getComboboxProps()), React.createElement("label", Object.assign({
    className: cn(styles$g['inputLabel'], customLabelClasses),
    htmlFor: inputProps.id
  }, getLabelProps()), labelText && React.createElement("span", {
    className: styles$g['inputLabelText']
  }, labelText), React.createElement("input", Object.assign({
    className: cn(styles$g['input'], customInputClasses),
    placeholder: placeholderText
  }, inputProps)))), React.createElement("ul", Object.assign({
    className: styles$g['suggestionsContainer']
  }, getMenuProps()), isOpen && itemFound && React.createElement("div", {
    className: styles$g['suggestionsScrollContainer']
  }, React.createElement("div", {
    className: styles$g['suggestions']
  }, suggestionsState.map(function (suggestion, index) {
    var _cn;

    return React.createElement("li", Object.assign({
      className: cn(styles$g['item'], (_cn = {}, _cn[styles$g['itemIsSelected']] = highlightedIndex === index, _cn)),
      // eslint-disable-next-line react/no-array-index-key
      key: "" + suggestion + index
    }, getItemProps({
      item: suggestion,
      index: index
    })), React.createElement(DropdownItem, {
      text: suggestion
    }));
  })))), helpText && React.createElement("div", {
    className: styles$g['helptext']
  }, React.createElement(Text, {
    size: "small",
    isHelpText: true
  }, helpText)));
};

Autosuggest.defaultProps = {
  createItem: false,
  customInputClasses: undefined,
  customLabelClasses: undefined,
  helpText: undefined,
  isDisabled: false,
  labelText: undefined,
  resetInput: false,
  storeInputValue: undefined
};
Autosuggest.propTypes = {
  createItem: PropTypes.bool,
  customInputClasses: PropTypes.string,
  customLabelClasses: PropTypes.string,
  helpText: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  labelText: PropTypes.string,
  placeholderText: PropTypes.string.isRequired,
  resetInput: PropTypes.bool,
  selectItem: PropTypes.func.isRequired,
  storeInputValue: PropTypes.func,
  suggestions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};

var styles$f = {"checkboxLabelText":"storyliner-mzCvXQ9F","checkboxLabelTextHorizontal":"storyliner-IxYEjwJC","checkboxLabelTextVertical":"storyliner-j2h4uKfX","checkboxLabel":"storyliner-l9Mzv8Cb","checkboxLabelHorizontal":"storyliner-Xex-9vHv","checkboxLabelVertical":"storyliner-w00BXuU-","checkboxInput":"storyliner-29CmMRjo"};

/* eslint-disable react/no-danger */
var CheckboxOrientationEnum;

(function (CheckboxOrientationEnum) {
  CheckboxOrientationEnum["vertical"] = "vertical";
  CheckboxOrientationEnum["horizontal"] = "horizontal";
})(CheckboxOrientationEnum || (CheckboxOrientationEnum = {})); // Checkbox component


var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      formId = _ref.formId,
      inputId = _ref.inputId,
      inputName = _ref.inputName,
      labelText = _ref.labelText,
      onChange = _ref.onChange,
      orientation = _ref.orientation,
      required = _ref.required;
  // init render
  var labelStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$f['checkboxLabel'], (_cn = {}, _cn[styles$f['checkboxLabelHorizontal']] = orientation === 'horizontal', _cn[styles$f['checkboxLabelVertical']] = orientation === 'vertical', _cn));
  }, [orientation]);
  var textStyles = React.useMemo(function () {
    var _cn2;

    return cn(styles$f['checkboxLabelText'], (_cn2 = {}, _cn2[styles$f['checkboxLabelTextHorizontal']] = orientation === 'horizontal', _cn2[styles$f['checkboxLabelTextVertical']] = orientation === 'vertical', _cn2));
  }, [orientation]);
  return React.createElement("label", {
    className: labelStyles,
    htmlFor: inputId
  }, React.createElement("input", {
    checked: checked,
    form: formId,
    id: inputId,
    name: inputName,
    onChange: onChange,
    required: required,
    type: "checkbox",
    className: styles$f['checkboxInput']
  }), labelText && React.createElement("span", {
    className: textStyles,
    dangerouslySetInnerHTML: {
      __html: labelText
    }
  }));
};

Checkbox.defaultProps = {
  formId: undefined,
  labelText: undefined,
  orientation: 'horizontal',
  required: false
};
Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  formId: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  orientation: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(CheckboxOrientationEnum)),
  required: PropTypes.bool
};

var styles$e = {"dropzone":"storyliner-D8zXFWNK","dropzoneIsDisabled":"storyliner-FUBMvqSJ"};

var content = {
  de: {
    errorMessages: {
      abort: 'Der Vorgang wurde abgebrochen.',
      error: 'Es ist ein Fehler aufgetreten.'
    }
  },
  en: {
    errorMessages: {
      abort: 'The operation was canceled.',
      error: 'An error has occurred.'
    }
  }
}; // Dropzone component

var Dropzone = function Dropzone(_ref) {
  var _cn;

  var acceptedTypes = _ref.acceptedTypes,
      children = _ref.children,
      dropzoneId = _ref.dropzoneId,
      isDisabled = _ref.isDisabled,
      locale = _ref.locale,
      uploadFunc = _ref.uploadFunc;
  // init vars
  var t = React.useMemo(function () {
    return content[locale || 'en'];
  }, [locale]); // init func

  var onDrop = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(acceptedFiles) {
      var file, path, name, type, size, filename, fileType, fileSize, reader;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isDisabled) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              // get file
              file = acceptedFiles[0];
              path = file.path, name = file.name, type = file.type, size = file.size; // construct file obj

              filename = name;
              fileType = type;
              fileSize = size; // init fileReader
              // NOTE: https://flaviocopes.com/filereader/

              reader = new FileReader(); // file upload abortion

              reader.onabort = function () {
                // notify user
                toast.error(t.errorMessages.abort);
              }; // on upload error


              reader.onerror = function () {
                toast.error(t.errorMessages.error);
              }; // init stream and upload file


              reader.onload = function () {
                var fileData = reader.result;

                if (fileType.includes('image')) {
                  var img = new Image();

                  img.onload = function () {
                    uploadFunc({
                      file: file,
                      fileData: fileData,
                      fileHeight: img.height,
                      fileSize: fileSize,
                      fileType: fileType,
                      fileWidth: img.width,
                      filename: filename,
                      path: path
                    });
                  };

                  img.src = reader.result;
                } else {
                  uploadFunc({
                    file: file,
                    fileData: fileData,
                    fileSize: fileSize,
                    fileType: fileType,
                    filename: filename,
                    path: path
                  });
                }
              }; // read as data url
              // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL


              reader.readAsDataURL(file);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [isDisabled, uploadFunc, t]); // init dropzone

  var _useDropzone = useDropzone({
    accept: acceptedTypes,
    maxFiles: 1,
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps; // render


  return React.createElement("div", Object.assign({
    className: cn(styles$e['dropzone'], (_cn = {}, _cn[styles$e['dropzoneIsDisabled']] = isDisabled, _cn)),
    contentEditable: false,
    id: dropzoneId,
    tabIndex: -1
  }, getRootProps()), React.createElement("input", Object.assign({}, getInputProps(), {
    tabIndex: -1,
    disabled: isDisabled
  })), children);
};

Dropzone.defaultProps = {
  acceptedTypes: 'image/*',
  dropzoneId: undefined,
  isDisabled: false
};
Dropzone.propTypes = {
  acceptedTypes: PropTypes.string,
  children: PropTypes.node.isRequired,
  dropzoneId: PropTypes.string,
  isDisabled: PropTypes.bool,
  locale: PropTypes.oneOf( /*#__PURE__*/Object.values(LocaleEnum)).isRequired,
  uploadFunc: PropTypes.func.isRequired
};
Dropzone.displayName = 'Dropzone';

var styles$d = {"form":"storyliner-di0MFa0t"};

// import node_modules

var Form = function Form(_ref) {
  var autoComplete = _ref.autoComplete,
      children = _ref.children,
      formId = _ref.formId,
      method = _ref.method,
      onSubmit = _ref.onSubmit;
  return React.createElement("form", {
    autoComplete: autoComplete,
    className: styles$d['form'],
    id: formId,
    method: method,
    noValidate: true,
    onSubmit: onSubmit
  }, children);
};

Form.defaultProps = {
  autoComplete: 'off',
  method: 'POST'
};
Form.propTypes = {
  autoComplete: PropTypes.string,
  children: PropTypes.node.isRequired,
  formId: PropTypes.string.isRequired,
  method: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};

var styles$c = {"inputIcon":"storyliner-MVxE0IRO","input":"storyliner-CUctCEDO","inputHasError":"storyliner-QtWorkuB","inputHasIcon":"storyliner-e01yypOJ","inputLabelText":"storyliner-4yEgUP6x","inputLabel":"storyliner-OceXes8T"};

// import node_modules

var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var customInputClasses = _ref.customInputClasses,
      customLabelClasses = _ref.customLabelClasses,
      formId = _ref.formId,
      hasError = _ref.hasError,
      inputIcon = _ref.inputIcon,
      inputId = _ref.inputId,
      inputName = _ref.inputName,
      isDisabled = _ref.isDisabled,
      labelText = _ref.labelText,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      required = _ref.required,
      type = _ref.type,
      value = _ref.value;
  // init render
  var inputStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$c['input'], 'group-hover:border-gray-one group-hover:text-black dark:group-hover:border-gray-two dark:group-hover:text-white', 'group-focus-within:border-gray-one group-focus-within:text-black dark:group-focus-within:border-gray-two dark:group-focus-within:text-white', (_cn = {}, _cn[styles$c['inputHasError']] = hasError, _cn[styles$c['inputHasIcon']] = inputIcon, _cn['group-focus-within:border-error group-focus-within:focus:ring-error group-focus-within:focus:ring-opacity-50 dark:group-focus-within:border-error-dark dark:group-focus-within:focus:ring-error-dark'] = hasError, _cn['group-hover:border-error group-hover:focus:ring-error group-hover:focus:ring-opacity-50 dark:group-hover:border-error-dark dark:group-hover:focus:ring-error-dark'] = hasError, _cn), customInputClasses);
  }, [customInputClasses, hasError, inputIcon]);
  var labelStyles = React.useMemo(function () {
    return cn(styles$c['inputLabel'], 'group', customLabelClasses);
  }, [customLabelClasses]);
  return React.createElement("label", {
    htmlFor: inputId,
    className: labelStyles
  }, labelText && React.createElement("span", {
    className: styles$c['inputLabelText']
  }, labelText), React.createElement("input", {
    "aria-label": placeholder,
    autoCapitalize: "off",
    autoComplete: "off",
    autoCorrect: "off",
    className: inputStyles,
    disabled: isDisabled,
    form: formId,
    id: inputId,
    name: inputName,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    ref: ref,
    required: required,
    tabIndex: 0,
    title: placeholder,
    type: type,
    value: value
  }), inputIcon && React.createElement("span", {
    className: styles$c['inputIcon']
  }, React.createElement(RemixIcon, {
    iconName: inputIcon
  })));
});
Input.defaultProps = {
  customInputClasses: undefined,
  customLabelClasses: undefined,
  formId: '',
  hasError: false,
  inputIcon: undefined,
  isDisabled: false,
  labelText: undefined,
  onBlur: function onBlur() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  required: false
};
Input.propTypes = {
  customInputClasses: PropTypes.string,
  customLabelClasses: PropTypes.string,
  formId: PropTypes.string,
  hasError: PropTypes.bool,
  inputIcon: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  labelText: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['email', 'text', 'password', 'url']).isRequired,
  value: PropTypes.string.isRequired
};
Input.displayName = 'Input';

var styles$b = {"select":"storyliner-5-IcoKsL","selectIsDisabled":"storyliner-nqiNn4Wo","selectIsSmall":"storyliner-WJlUS7A-","selectOption":"storyliner--QnPHfdE","labelText":"storyliner-6uQTn5Zl","label":"storyliner-GSfV0hkf","labelIsDisabled":"storyliner-jh5MZ47z"};

/* eslint-disable react/no-danger */

var Select = function Select(_ref) {
  var defaultOption = _ref.defaultOption,
      defaultOptionDisabled = _ref.defaultOptionDisabled,
      formId = _ref.formId,
      isSmall = _ref.isSmall,
      isDisabled = _ref.isDisabled,
      labelText = _ref.labelText,
      onChange = _ref.onChange,
      options = _ref.options,
      selectId = _ref.selectId,
      selectName = _ref.selectName,
      value = _ref.value;
  // init styles
  var labelStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$b['label'], 'group', (_cn = {}, _cn[styles$b['labelIsDisabled']] = isDisabled, _cn));
  }, [isDisabled]);
  var selectStyles = React.useMemo(function () {
    var _cn2;

    return cn(styles$b['select'], 'group-hover:border-gray-one dark:group-hover:border-gray-two group-hover:text-black dark:group-hover:text-white', 'group-focus-within:border-gray-one dark:group-focus-within:border-gray-two group-focus-within:text-black dark:group-focus-within:text-white', (_cn2 = {}, _cn2[styles$b['selectIsDisabled']] = isDisabled, _cn2[styles$b['selectIsSmall']] = isSmall, _cn2));
  }, [isDisabled, isSmall]);
  return React.createElement("label", {
    htmlFor: selectId,
    className: labelStyles
  }, labelText && React.createElement("span", {
    className: styles$b['labelText']
  }, labelText), React.createElement("select", {
    className: selectStyles,
    disabled: isDisabled,
    form: formId,
    id: selectId,
    name: selectName,
    onChange: onChange,
    value: value
  }, React.createElement("option", {
    className: styles$b['selectOption'],
    dangerouslySetInnerHTML: {
      __html: defaultOption
    },
    disabled: defaultOptionDisabled,
    value: ""
  }), options.map(function (option) {
    return React.createElement("option", {
      className: styles$b['selectOption'],
      dangerouslySetInnerHTML: {
        __html: option.title
      },
      key: option.id,
      value: option.id
    });
  })));
};

Select.defaultProps = {
  defaultOptionDisabled: false,
  formId: undefined,
  isDisabled: false,
  isSmall: false,
  labelText: undefined
};
Select.propTypes = {
  defaultOption: PropTypes.string.isRequired,
  defaultOptionDisabled: PropTypes.bool,
  formId: PropTypes.string,
  isDisabled: PropTypes.bool,
  isSmall: PropTypes.bool,
  labelText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf( PropTypes.exact({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired).isRequired,
  selectId: PropTypes.string.isRequired,
  selectName: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

var styles$a = {"container":"storyliner-9s2nD5Jf","pulse":"storyliner-UOqv06ue","containerIsRoundedFull":"storyliner--Btsqcbq","containerIsRounded2xl":"storyliner-zuUFP5Cg"};

// import node_modules

var SkeletonBlock = function SkeletonBlock(_ref) {
  var customClasses = _ref.customClasses,
      height = _ref.height,
      isRound = _ref.isRound,
      width = _ref.width;
  // init styles
  var skeletonStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$a['container'], (_cn = {}, _cn[styles$a['containerIsRoundedFull']] = isRound, _cn[styles$a['containerIsRounded2xl']] = !isRound, _cn), customClasses);
  }, [customClasses, isRound]); // render

  return React.createElement("div", {
    className: skeletonStyles,
    style: {
      height: height,
      width: width
    }
  });
};

SkeletonBlock.defaultProps = {
  customClasses: undefined,
  isRound: false
};
SkeletonBlock.propTypes = {
  customClasses: PropTypes.string,
  height: PropTypes.string.isRequired,
  isRound: PropTypes.bool,
  width: PropTypes.string.isRequired
};
SkeletonBlock.displayName = 'SkeletonBlock';

var styles$9 = {"switch":"storyliner-6-xIAFWv","switchIsRow":"storyliner-nEDEfmig","switchIsReverse":"storyliner-635gZ4k8","switchIsLeft":"storyliner-w-KUQXc5","switchIsCenter":"storyliner-9akK96dX","switchIsRight":"storyliner-YjLwsg8f","switchSlider":"storyliner-oLdpHeFO","switchLabel":"storyliner-puyVXiVF","switchContent":"storyliner-E4QLY4Pf","switchInput":"storyliner-Yf3Jxcbq","switchLabelText":"storyliner-vXnm6XWm","switchLabelTextIsLeft":"storyliner-rMPP7b-E","switchLabelTextIsCenter":"storyliner-qL9zcPkU","switchLabelTextIsRight":"storyliner-Xwbgbuf0","switchLabelTextIsBold":"storyliner-INJGWnD6","switchLabelHelpText":"storyliner-S5Zke-6W","switchLabelHelpTextIsLeft":"storyliner-MDvdPIO4","switchLabelHelpTextIsCenter":"storyliner-ObEjPm3l","switchLabelHelpTextIsRight":"storyliner-kzNPqHiW"};

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
var SwitchAlignmentEnum;

(function (SwitchAlignmentEnum) {
  SwitchAlignmentEnum["LEFT"] = "left";
  SwitchAlignmentEnum["CENTER"] = "center";
  SwitchAlignmentEnum["RIGHT"] = "right";
})(SwitchAlignmentEnum || (SwitchAlignmentEnum = {}));

var SwitchDirectionEnum;

(function (SwitchDirectionEnum) {
  SwitchDirectionEnum["REVERSE"] = "reverse";
  SwitchDirectionEnum["ROW"] = "row";
})(SwitchDirectionEnum || (SwitchDirectionEnum = {})); // SwitchComponent component


var Switch = function Switch(_ref) {
  var alignment = _ref.alignment,
      checked = _ref.checked,
      direction = _ref.direction,
      disabled = _ref.disabled,
      helpText = _ref.helpText,
      inputId = _ref.inputId,
      labelText = _ref.labelText,
      loading = _ref.loading,
      onChange = _ref.onChange;
  // init styles
  var switchStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$9['switch'], (_cn = {}, _cn[styles$9['switchIsRow']] = direction === SwitchDirectionEnum.ROW, _cn[styles$9['switchIsReverse']] = direction === SwitchDirectionEnum.REVERSE, _cn[styles$9['switchIsLeft']] = alignment === SwitchAlignmentEnum.LEFT, _cn[styles$9['switchIsCenter']] = alignment === SwitchAlignmentEnum.CENTER, _cn[styles$9['switchIsRight']] = alignment === SwitchAlignmentEnum.RIGHT, _cn));
  }, [alignment, direction]);
  var textStyles = React.useMemo(function () {
    var _cn2;

    return cn(styles$9['switchLabelText'], (_cn2 = {}, _cn2[styles$9['switchLabelTextIsLeft']] = alignment === SwitchAlignmentEnum.LEFT, _cn2[styles$9['switchLabelTextIsCenter']] = alignment === SwitchAlignmentEnum.CENTER, _cn2[styles$9['switchLabelTextIsRight']] = alignment === SwitchAlignmentEnum.RIGHT, _cn2[styles$9['switchLabelTextIsBold']] = !helpText, _cn2));
  }, [alignment, helpText]);
  var helpTextStyles = React.useMemo(function () {
    var _cn3;

    return cn(styles$9['switchLabelHelpText'], (_cn3 = {}, _cn3[styles$9['switchLabelHelpTextIsLeft']] = alignment === SwitchAlignmentEnum.LEFT, _cn3[styles$9['switchLabelHelpTextIsCenter']] = alignment === SwitchAlignmentEnum.CENTER, _cn3[styles$9['switchLabelHelpTextIsRight']] = alignment === SwitchAlignmentEnum.RIGHT, _cn3));
  }, [alignment]); // render

  return React.createElement("div", {
    className: switchStyles
  }, React.createElement("label", {
    className: cn(styles$9['switchLabel'], 'group'),
    htmlFor: inputId
  }, loading ? React.createElement(SkeletonBlock, {
    height: "24px",
    width: "40px"
  }) : React.createElement(React.Fragment, null, React.createElement("input", {
    checked: checked,
    className: styles$9['switchInput'],
    disabled: disabled,
    id: inputId,
    onChange: onChange,
    type: "checkbox"
  }), React.createElement("span", {
    className: cn(styles$9['switchSlider'], 'group-focus-within:before:ring-gray-one·group-focus-within:before:ring-opacity-50·group-focus-within:before:ring-offset-0·dark:group-focus-within:before:ring-gray-one·dark:group-focus-within:before:focus:ring-opacity-5'),
    tabIndex: 0
  }))), React.createElement("div", {
    className: styles$9['switchContent']
  }, React.createElement("div", {
    className: textStyles
  }, labelText), helpText && React.createElement("div", {
    className: helpTextStyles
  }, helpText)));
};

Switch.defaultProps = {
  alignment: 'left',
  direction: 'row',
  disabled: false,
  helpText: undefined,
  inputId: undefined,
  loading: false
};
Switch.propTypes = {
  alignment: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(SwitchAlignmentEnum)),
  checked: PropTypes.bool.isRequired,
  direction: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(SwitchDirectionEnum)),
  disabled: PropTypes.bool,
  helpText: PropTypes.string,
  inputId: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

var styles$8 = {"textarea":"storyliner-tmmCtygY","textareaHasError":"storyliner-cqxAR5nH","textareaLabelText":"storyliner-kxmJQ9PB","textareaLabel":"storyliner-FTb1fpdU"};

/* eslint-disable @typescript-eslint/ban-ts-comment */

var Textarea = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var formId = _ref.formId,
      hasError = _ref.hasError,
      inputId = _ref.inputId,
      inputName = _ref.inputName,
      isDisabled = _ref.isDisabled,
      labelText = _ref.labelText,
      minRows = _ref.minRows,
      customTextareaClasses = _ref.customTextareaClasses,
      customLabelClasses = _ref.customLabelClasses,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      required = _ref.required,
      value = _ref.value;
  // init render
  var textareaStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$8['textarea'], 'group-hover:border-gray-one dark:group-hover:border-gray-two group-hover:text-black dark:group-hover:text-white', 'group-focus-within:border-gray-one dark:group-focus-within:border-gray-two group-focus-within:text-black dark:group-focus-within:text-white', (_cn = {}, _cn[styles$8['textareaHasError']] = hasError, _cn['group-hover:border-error dark:group-hover:border-error-dark group-hover:focus:ring-error dark:group-hover:focus:ring-error-dark group-hover:focus:ring-opacity-50'] = hasError, _cn['group-focus-within:border-error dark:group-focus-within:border-error-dark group-focus-within:focus:ring-error dark:group-focus-within:focus:ring-error-dark group-focus-within:focus:ring-opacity-50'] = hasError, _cn), customTextareaClasses);
  }, [customTextareaClasses, hasError]);
  var labelStyles = React.useMemo(function () {
    return cn(styles$8['textareaLabel'], 'group', customLabelClasses);
  }, [customLabelClasses]);
  return React.createElement("label", {
    htmlFor: inputId,
    className: labelStyles
  }, labelText && React.createElement("span", {
    className: styles$8['textareaLabelText']
  }, labelText), React.createElement(TextareaAutosize, {
    autoComplete: "off",
    autoCorrect: "off",
    className: textareaStyles,
    disabled: isDisabled,
    form: formId,
    id: inputId,
    minRows: minRows,
    name: inputName,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    // @ts-ignore
    ref: ref,
    required: required,
    title: placeholder,
    value: value
  }));
});
Textarea.defaultProps = {
  customLabelClasses: undefined,
  customTextareaClasses: undefined,
  formId: '',
  hasError: false,
  isDisabled: false,
  labelText: undefined,
  minRows: 2,
  onBlur: function onBlur() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  required: false
};
Textarea.propTypes = {
  customLabelClasses: PropTypes.string,
  customTextareaClasses: PropTypes.string,
  formId: PropTypes.string,
  hasError: PropTypes.bool,
  inputId: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  labelText: PropTypes.string,
  minRows: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired
};
Textarea.displayName = 'Textarea';

var styles$7 = {"spacerIsTransparent":"storyliner-9LeP9Dvk","spacerIsWhite":"storyliner-gDQU0JRO"};

// import node_modules

function getWindowDimensions() {
  // due to ssr / gatsby
  if (typeof window === 'undefined') {
    return {
      windowWidth: 0,
      windowHeight: 0
    };
  }

  var _window = window,
      width = _window.innerWidth,
      height = _window.innerHeight;
  return {
    windowWidth: width,
    windowHeight: height
  };
}

var SpacerBackgroundColorEnum;

(function (SpacerBackgroundColorEnum) {
  SpacerBackgroundColorEnum["transparent"] = "transparent";
  SpacerBackgroundColorEnum["white"] = "white";
})(SpacerBackgroundColorEnum || (SpacerBackgroundColorEnum = {})); // Spacer component


var Spacer = function Spacer(_ref) {
  var backgroundColor = _ref.backgroundColor,
      height = _ref.height,
      mobileHeight = _ref.mobileHeight,
      tabletHeight = _ref.tabletHeight,
      width = _ref.width;

  // init states
  var _useImmer = useImmer(height),
      spacerHeight = _useImmer[0],
      setSpacerHeight = _useImmer[1];

  var _useImmer2 = useImmer(getWindowDimensions()),
      windowWidth = _useImmer2[0].windowWidth,
      setWindowDimensions = _useImmer2[1]; // init func


  var onResizeWindow = React.useCallback(function () {
    setWindowDimensions(getWindowDimensions());
  }, [setWindowDimensions]); // handle data changes

  React.useEffect(function () {
    window.addEventListener('resize', onResizeWindow);
    return function () {
      return window.removeEventListener('resize', onResizeWindow);
    };
  }, [onResizeWindow]);
  React.useEffect(function () {
    // height
    var nextHeight = height;

    if (tabletHeight && windowWidth < 1024) {
      nextHeight = tabletHeight;
    }

    if (mobileHeight && windowWidth < 768) {
      nextHeight = mobileHeight;
    }

    setSpacerHeight(nextHeight);
  }, [height, mobileHeight, setSpacerHeight, tabletHeight, windowWidth]); // init styles

  var spacerStyles = React.useMemo(function () {
    var _cn;

    return cn((_cn = {}, _cn[styles$7['spacerIsTransparent']] = backgroundColor === SpacerBackgroundColorEnum.transparent, _cn[styles$7['spacerIsWhite']] = backgroundColor === SpacerBackgroundColorEnum.white, _cn));
  }, [backgroundColor]); // render spacer

  return React.createElement("div", {
    className: spacerStyles,
    style: {
      height: spacerHeight,
      width: width
    }
  });
};

Spacer.defaultProps = {
  backgroundColor: 'transparent',
  mobileHeight: undefined,
  tabletHeight: undefined,
  width: '100%'
};
Spacer.propTypes = {
  backgroundColor: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/Object.values(SpacerBackgroundColorEnum)),
  height: PropTypes.string.isRequired,
  mobileHeight: PropTypes.string,
  tabletHeight: PropTypes.string,
  width: PropTypes.string
};
Spacer.displayName = 'Spacer';

var styles$6 = {"grid":"storyliner-YS35aWaY","gridEndContainer":"storyliner-3r1t6uW9","gridEndText":"storyliner-DTVvaOgf","dark":"storyliner-CnpnUtGm","gridContainer":"storyliner-LEoZJ-ax","gridCol3":"storyliner-V5abN4su","gridCol4":"storyliner-SXRrhWYz","gridCol5":"storyliner-o9aOWGHp","gridIsList":"storyliner--M0UBg2o","loadingGridContainer":"storyliner-p1AtT19Y","loadingGridCol3":"storyliner-UKLTSg2-","loadingGridCol4":"storyliner-CW8xCABE","loadingGridCol5":"storyliner-KxmO0K1j","loadingGridIsList":"storyliner-XlyUMZhP"};

// import node_modules

var InfiniteGrid = function InfiniteGrid(_ref) {
  var EmptyStateComponent = _ref.EmptyStateComponent,
      ItemComponent = _ref.ItemComponent,
      allItemsLoadedText = _ref.allItemsLoadedText,
      columns = _ref.columns,
      hasMore = _ref.hasMore,
      isList = _ref.isList,
      isLoading = _ref.isLoading,
      itemHeight = _ref.itemHeight,
      items = _ref.items,
      loadMore = _ref.loadMore,
      parentElement = _ref.parentElement;
  // init vars
  var skeletonItems = React.useMemo(function () {
    var skeletonItemsArray = Array.from(Array(16).keys()); // list

    if (isList) {
      skeletonItemsArray = Array.from(Array(3).keys());
    } // col3


    if (!isList && columns === 3) {
      skeletonItemsArray = Array.from(Array(9).keys());
    } // col4


    if (!isList && columns === 4) {
      skeletonItemsArray = Array.from(Array(12).keys());
    } // col5


    if (!isList && columns === 5) {
      skeletonItemsArray = Array.from(Array(15).keys());
    }

    return skeletonItemsArray;
  }, [columns, isList]); // generate class

  var loadingContainerStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$6['loadingGridContainer'], (_cn = {}, _cn[styles$6['loadingGridIsList']] = isList, _cn[styles$6['loadingGridCol3']] = !isList && columns === 3, _cn[styles$6['loadingGridCol4']] = !isList && columns === 4, _cn[styles$6['loadingGridCol5']] = !isList && columns === 5, _cn));
  }, [columns, isList]);
  var gridContainerStyles = React.useMemo(function () {
    var _cn2;

    return cn(styles$6['gridContainer'], (_cn2 = {}, _cn2[styles$6['gridIsList']] = isList, _cn2[styles$6['gridCol3']] = !isList && columns === 3, _cn2[styles$6['gridCol4']] = !isList && columns === 4, _cn2[styles$6['gridCol5']] = !isList && columns === 5, _cn2));
  }, [columns, isList]); // loading

  if (isLoading) {
    return React.createElement("div", {
      className: styles$6['grid']
    }, React.createElement("div", {
      className: loadingContainerStyles
    }, skeletonItems.map(function (item) {
      return React.createElement("div", {
        key: item
      }, React.createElement(SkeletonBlock, {
        height: itemHeight + "px",
        width: "100%"
      }));
    })));
  } // empty state


  if ((items == null ? void 0 : items.length) === 0) {
    return React.createElement("div", {
      className: styles$6['grid']
    }, React.createElement(EmptyStateComponent, null));
  }

  return React.createElement("div", {
    className: styles$6['grid']
  }, React.createElement("div", {
    className: gridContainerStyles
  }, React.createElement(InfiniteScroll, {
    hasMore: hasMore,
    loadMore: loadMore,
    pageStart: 0,
    threshold: itemHeight * 3,
    loader: React.createElement(React.Fragment, {
      key: 0
    }, skeletonItems.map(function (item) {
      return React.createElement(SkeletonBlock, {
        key: item,
        height: itemHeight + "px",
        width: "100%"
      });
    })),
    getScrollParent: function getScrollParent() {
      if (parentElement) {
        return parentElement;
      }

      return window;
    },
    useWindow: !parentElement
  }, items.map(function (item, index) {
    return React.createElement(ItemComponent, {
      item: item,
      key: (item == null ? void 0 : item.id) || (item == null ? void 0 : item.slug),
      position: index + 1,
      zIndex: items.length - index
    });
  }))), !hasMore && allItemsLoadedText && React.createElement("div", {
    className: styles$6['gridEndContainer']
  }, React.createElement("div", {
    className: styles$6['gridEndText']
  }, allItemsLoadedText)));
};

InfiniteGrid.defaultProps = {
  allItemsLoadedText: undefined,
  columns: 4,
  isList: false,
  parentElement: undefined
};
InfiniteGrid.propTypes = {
  EmptyStateComponent: PropTypes.func.isRequired,
  ItemComponent: PropTypes.func.isRequired,
  allItemsLoadedText: PropTypes.string,
  columns: PropTypes.number,
  hasMore: PropTypes.bool.isRequired,
  isList: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  itemHeight: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
  loadMore: PropTypes.func.isRequired,
  parentElement: /*#__PURE__*/PropTypes.oneOfType([// https://stackoverflow.com/questions/48007326/what-is-the-correct-proptype-for-a-ref-in-react/51127130#51127130
  // Either a function
  PropTypes.func,
  /*#__PURE__*/
  // Or the instance of a DOM native element (see the note about SSR)
  PropTypes.exact({
    current: PropTypes.elementType
  })])
};

var styles$5 = {"container":"storyliner-JkF19HLv","spinner":"storyliner-T3tR9KyQ","scale-out":"storyliner-NW5-BTql"};

// import node_modules

var Spinner = function Spinner() {
  return React.createElement("div", {
    className: styles$5['container']
  }, React.createElement("div", {
    className: styles$5['spinner']
  }));
};

Spinner.displayName = 'Spinner';

var styles$4 = {"grid":"storyliner-eOa-dFAw","endContainer":"storyliner-GFTEvLZo","endText":"storyliner-8Q6mf5aa"};

var _excluded = ["data", "index"],
    _excluded2 = ["data"];

var MasonryGrid = /*#__PURE__*/React.memo(function (_ref) {
  var EmptyStateComponent = _ref.EmptyStateComponent,
      ItemComponent = _ref.ItemComponent,
      allItemsLoadedText = _ref.allItemsLoadedText,
      columnGutter = _ref.columnGutter,
      columnWidth = _ref.columnWidth,
      hasMore = _ref.hasMore,
      isLoading = _ref.isLoading,
      isLoadingMore = _ref.isLoadingMore,
      items = _ref.items,
      limit = _ref.limit,
      loadMore = _ref.loadMore,
      masonryKey = _ref.masonryKey;
  // init ref
  var gridRef = React.createRef(); // init func

  var maybeLoadMore = useInfiniteLoader( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", hasMore && loadMore());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), {
    isItemLoaded: function isItemLoaded(index, masonryItems) {
      return !!masonryItems[index];
    },
    minimumBatchSize: limit
  });
  var onLowerZIndex = React.useCallback(function (_ref3) {
    var itemId = _ref3.itemId;
    var container = gridRef.current;
    var gridNodes = (container == null ? void 0 : container.childNodes) || [];
    var grid = gridNodes[0];

    if (grid != null && grid.childNodes) {
      var cards = grid.childNodes;
      cards.forEach(function (card) {
        if (card != null && card.childNodes) {
          var item = card.childNodes[0];

          if ((item == null ? void 0 : item.id) === itemId) {
            // @ts-ignore
            card.style.zIndex = 1000;
          } else {
            // @ts-ignore
            card.style.zIndex = 0;
          }
        }
      });
    }
  }, [gridRef]);
  var onResetZIndex = React.useCallback(function () {
    var container = gridRef.current;
    var gridNodes = (container == null ? void 0 : container.childNodes) || [];
    var grid = gridNodes[0];

    if (grid != null && grid.childNodes) {
      var cards = grid.childNodes;
      cards.forEach(function (card) {
        // @ts-ignore
        card.style.zIndex = 1;
      });
    }
  }, [gridRef]);
  var onRenderComponent = React.useCallback(function (_ref4) {
    var data = _ref4.data,
        index = _ref4.index,
        rest = _objectWithoutPropertiesLoose(_ref4, _excluded);

    return React.createElement(ItemComponent, Object.assign({
      index: index,
      item: data,
      lowerZIndex: onLowerZIndex,
      resetZIndex: onResetZIndex
    }, rest));
  }, [ItemComponent, onLowerZIndex, onResetZIndex]);
  var onRenderSkeletonLoader = React.useCallback(function (_ref5) {
    var data = _ref5.data,
        rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);

    return React.createElement("div", Object.assign({}, rest), React.createElement(SkeletonBlock, {
      height: data.height,
      width: "100%"
    }));
  }, []); // LOADING

  if (isLoading) {
    // init loading
    var skeletonLoadingItems = [{
      id: 1,
      height: '200px'
    }, {
      id: 2,
      height: '300px'
    }, {
      id: 3,
      height: '400px'
    }, {
      id: 4,
      height: '500px'
    }, {
      id: 5,
      height: '200px'
    }, {
      id: 6,
      height: '300px'
    }, {
      id: 7,
      height: '400px'
    }, {
      id: 8,
      height: '500px'
    }, {
      id: 9,
      height: '200px'
    }, {
      id: 10,
      height: '300px'
    }];
    return React.createElement("div", {
      className: styles$4['grid'],
      ref: gridRef
    }, React.createElement(Masonry, {
      columnGutter: columnGutter,
      columnWidth: columnWidth,
      items: skeletonLoadingItems,
      key: "loading",
      onRender: maybeLoadMore,
      overscanBy: 4,
      render: onRenderSkeletonLoader
    }));
  } // EMPTY STATE


  if ((items == null ? void 0 : items.length) === 0) {
    return React.createElement("div", {
      className: styles$4['grid'],
      ref: gridRef
    }, React.createElement(EmptyStateComponent, null));
  } // RENDER


  return React.createElement("div", {
    className: styles$4['grid'],
    ref: gridRef
  }, React.createElement(Masonry, {
    columnGutter: columnGutter,
    columnWidth: columnWidth,
    items: items,
    key: masonryKey,
    onRender: maybeLoadMore,
    overscanBy: 4,
    render: onRenderComponent
  }), hasMore && isLoadingMore && React.createElement("div", {
    className: styles$4['endContainer']
  }, React.createElement("div", {
    className: styles$4['endText']
  }, React.createElement(Spinner, null))), !hasMore && React.createElement("div", {
    className: styles$4['endContainer']
  }, React.createElement("div", {
    className: styles$4['endText']
  }, allItemsLoadedText)));
});
MasonryGrid.defaultProps = {
  columnGutter: 16,
  columnWidth: 280
};
MasonryGrid.propTypes = {
  EmptyStateComponent: PropTypes.func.isRequired,
  ItemComponent: PropTypes.func.isRequired,
  allItemsLoadedText: PropTypes.string.isRequired,
  columnGutter: PropTypes.number,
  columnWidth: PropTypes.number,
  hasMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingMore: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  limit: PropTypes.number.isRequired,
  loadMore: PropTypes.func.isRequired,
  masonryKey: PropTypes.string.isRequired
};
MasonryGrid.displayName = 'MasonryGrid';

var styles$3 = {"table":"storyliner-9IMsZy2y","tableIsFixed":"storyliner-y4v2okLN","head":"storyliner-z0E1UQmd","header":"storyliner-tQRLMXkG","column":"storyliner-Av70Zuj2","row":"storyliner-Y5Fy6n8W"};

/* eslint-disable @typescript-eslint/no-explicit-any */

var TableHead = function TableHead(_ref) {
  var customClasses = _ref.customClasses,
      label = _ref.label;
  // init styles
  var tableHeadStyles = React.useMemo(function () {
    return cn(styles$3['header'], customClasses);
  }, [customClasses]);
  return React.createElement("th", {
    className: tableHeadStyles
  }, label);
};
TableHead.defaultProps = {
  customClasses: undefined
};
TableHead.propTypes = {
  customClasses: PropTypes.string,
  label: PropTypes.string.isRequired
};
var TableCol = function TableCol(_ref2) {
  var children = _ref2.children;
  return React.createElement("td", {
    className: styles$3['column']
  }, children);
};
TableCol.propTypes = {
  children: PropTypes.node.isRequired
};
var TableRow = function TableRow(_ref3) {
  var children = _ref3.children;
  return React.createElement("tr", {
    className: styles$3['row']
  }, children);
};
TableRow.propTypes = {
  children: PropTypes.node.isRequired
}; // Table component

var Table = function Table(_ref4) {
  var isFixed = _ref4.isFixed,
      tableHeads = _ref4.tableHeads,
      tableRows = _ref4.tableRows;
  // init styles
  var tableStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$3['table'], (_cn = {}, _cn[styles$3['tableIsFixed']] = isFixed, _cn));
  }, [isFixed]); // render

  return React.createElement("table", {
    className: tableStyles
  }, React.createElement("thead", {
    className: styles$3['head']
  }, React.createElement(TableRow, null, tableHeads.map(function (tableHead) {
    return React.createElement(TableHead, {
      customClasses: tableHead.customClasses,
      key: tableHead.label,
      label: tableHead.label
    });
  }))), React.createElement("tbody", null, tableRows.map(function (tableRow) {
    return React.createElement(TableRow, {
      key: tableRow.id
    }, tableRow.tableCols.map(function (tableCol) {
      return React.createElement(TableCol, {
        key: tableCol.id
      }, tableCol.content);
    }));
  })));
};

Table.defaultProps = {
  isFixed: false
};
Table.propTypes = {
  isFixed: PropTypes.bool,
  tableHeads: PropTypes.arrayOf( PropTypes.exact({
    customClasses: PropTypes.string,
    label: PropTypes.string.isRequired
  }).isRequired).isRequired,
  tableRows: PropTypes.arrayOf( PropTypes.exact({
    id: PropTypes.string.isRequired,
    tableCols: PropTypes.arrayOf( PropTypes.exact({
      id: PropTypes.string.isRequired,
      content: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]).isRequired
    }).isRequired).isRequired
  }).isRequired).isRequired
};
Table.displayName = 'Table';

var classNames$2 = {"container":"storyliner-uyuKbRbv","fade-in":"storyliner-dTF-McPu"};

var ContextMenu = function ContextMenu(_ref) {
  var children = _ref.children,
      element = _ref.element;

  // init states
  var _useImmer = useImmer({
    x: 0,
    y: 0
  }),
      anchorPointState = _useImmer[0],
      setAnchorPointState = _useImmer[1];

  var _useImmer2 = useImmer(false),
      contextMenuState = _useImmer2[0],
      setContextMenuState = _useImmer2[1];

  var _useImmer3 = useImmer(0),
      contextMenuHeightState = _useImmer3[0],
      setContextMenuHeightState = _useImmer3[1]; // init refs


  var contextMenuRef = React.createRef(); // init func

  var onInitContextMenu = React.useCallback(function (event) {
    event.preventDefault();
    setAnchorPointState({
      x: event.pageX,
      y: event.pageY
    });
    setContextMenuState(true);
  }, [setAnchorPointState, setContextMenuState]);
  var onCheckElementInViewport = React.useCallback(function () {
    // check element
    if (!element) {
      return false;
    } // get dimensions


    var rect = element == null ? void 0 : element.getBoundingClientRect(); // return check

    return rect.top >= 0 && rect.left >= 0 && rect.bottom + contextMenuHeightState <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }, [contextMenuHeightState, element]);
  var onHandleClick = React.useCallback(function () {
    return contextMenuState ? setContextMenuState(false) : null;
  }, [contextMenuState, setContextMenuState]); // handle data changes

  React.useEffect(function () {
    // listen to context menu clicks
    element == null ? void 0 : element.addEventListener('contextmenu', onInitContextMenu);
    document.addEventListener('click', onHandleClick); // unsubscribe listener

    return function () {
      element == null ? void 0 : element.removeEventListener('contextmenu', onInitContextMenu);
      document.removeEventListener('click', onHandleClick);
    };
  }, [element, onInitContextMenu, onHandleClick]);
  React.useEffect(function () {
    // get document toolbar inner
    var contextMenu = contextMenuRef.current; // eslint-disable-next-line react/function-component-definition

    if (!contextMenu) return function () {
      return null;
    }; // observe resizing

    var resizeObserver = new ResizeObserver(function (entries) {
      for (var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;) {
        var entry = _step.value;
        var cm = entry.contentRect;
        setContextMenuHeightState(cm == null ? void 0 : cm.height);
      }
    }); // observe changes

    resizeObserver.observe(contextMenu); // unsubscribe

    return function () {
      resizeObserver.unobserve(contextMenu);
    };
  }, [contextMenuRef, setContextMenuHeightState]); // init render

  var inViewPort = onCheckElementInViewport();
  var top = inViewPort ? anchorPointState.y : anchorPointState.y - contextMenuHeightState;
  var left = anchorPointState.x;
  return React.createElement(StorylinerPortal, null, contextMenuState && React.createElement("div", {
    className: classNames$2['container'],
    ref: contextMenuRef,
    style: {
      top: top,
      left: left
    }
  }, children));
};

ContextMenu.defaultProps = {
  element: undefined
};
ContextMenu.propTypes = {
  children: PropTypes.node.isRequired,
  element: /*#__PURE__*/PropTypes.oneOfType([// https://stackoverflow.com/questions/48007326/what-is-the-correct-proptype-for-a-ref-in-react/51127130#51127130
  // Either a function
  PropTypes.func,
  /*#__PURE__*/
  // Or the instance of a DOM native element (see the note about SSR)
  PropTypes.exact({
    current: PropTypes.elementType
  })])
};

var classNames$1 = {"divider":"storyliner-11gWPlI5"};

// atoms/DropdownDivider

var DropdownDivider = function DropdownDivider() {
  return React.createElement("div", {
    className: classNames$1['divider']
  });
};

DropdownDivider.displayName = 'DropdownDivider';

var styles$2 = {"header":"storyliner-P5wpnlGw","headerText":"storyliner-HPRKhbcM"};

// import node_modules

var DropdownHeader = function DropdownHeader(_ref) {
  var headerText = _ref.headerText;
  return React.createElement("div", {
    className: styles$2['header']
  }, React.createElement("div", {
    className: styles$2['headerText']
  }, headerText));
};

DropdownHeader.propTypes = {
  headerText: PropTypes.string.isRequired
};
DropdownHeader.displayName = 'DropdownHeader';

/* eslint-disable react/no-danger */

var DropdownLinkItem = function DropdownLinkItem(_ref) {
  var LinkComponent = _ref.LinkComponent,
      handleClick = _ref.handleClick,
      helpText = _ref.helpText,
      icon = _ref.icon,
      iconIsHidden = _ref.iconIsHidden,
      image = _ref.image,
      imageIsRound = _ref.imageIsRound,
      isActive = _ref.isActive,
      isDanger = _ref.isDanger,
      isSelected = _ref.isSelected,
      isSmall = _ref.isSmall,
      text = _ref.text;
  // init func
  var onKeyPress = React.useCallback(function (event) {
    if (event.key === 'Enter' || event.key === 'Space') {
      event.preventDefault();

      if (handleClick) {
        handleClick();
      }
    }
  }, [handleClick]); // init styles

  var buttonStyles = React.useMemo(function () {
    var _cn;

    return cn(classNames$4['button'], (_cn = {}, _cn[classNames$4['buttonIsSmall']] = isSmall, _cn[classNames$4['buttonIsSelected']] = isSelected, _cn));
  }, [isSmall, isSelected]);
  var iconStyles = React.useMemo(function () {
    var _cn2;

    return cn(classNames$4['icon'], (_cn2 = {}, _cn2[classNames$4['iconIsHidden']] = iconIsHidden, _cn2[classNames$4['iconIsActive']] = isActive, _cn2[classNames$4['iconIsSmall']] = isSmall, _cn2[classNames$4['iconIsDanger']] = isDanger, _cn2));
  }, [iconIsHidden, isDanger, isActive, isSmall]);
  var textStyles = React.useMemo(function () {
    var _cn3;

    return cn(classNames$4['text'], (_cn3 = {}, _cn3[classNames$4['textIsActive']] = isActive, _cn3[classNames$4['textIsSmall']] = isSmall, _cn3[classNames$4['textIsDanger']] = isDanger, _cn3));
  }, [isDanger, isActive, isSmall]);
  var imageStyles = React.useMemo(function () {
    var _cn4;

    return cn(classNames$4['image'], (_cn4 = {}, _cn4[classNames$4['imageIsRound']] = imageIsRound, _cn4));
  }, [imageIsRound]);
  return React.createElement("div", {
    className: classNames$4['container']
  }, React.createElement(LinkComponent, null, React.createElement("div", {
    className: buttonStyles,
    onClick: handleClick,
    onKeyPress: onKeyPress,
    role: "button",
    tabIndex: 0
  }, icon && React.createElement("div", {
    className: iconStyles
  }, React.createElement(RemixIcon, {
    iconName: icon
  })), image && React.createElement("div", {
    className: imageStyles
  }, React.createElement("img", {
    alt: text,
    src: image,
    title: text
  })), React.createElement("div", {
    className: textStyles,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), helpText && React.createElement("div", {
    className: classNames$4['helptext'],
    dangerouslySetInnerHTML: {
      __html: helpText
    }
  }))));
};

DropdownLinkItem.defaultProps = {
  handleClick: function handleClick() {
    return null;
  },
  helpText: null,
  icon: null,
  iconIsHidden: false,
  image: null,
  imageIsRound: false,
  isActive: false,
  isDanger: false,
  isSelected: false,
  isSmall: false
};
DropdownLinkItem.propTypes = {
  LinkComponent: PropTypes.func.isRequired,
  handleClick: PropTypes.func,
  helpText: PropTypes.string,
  icon: PropTypes.string,
  iconIsHidden: PropTypes.bool,
  image: PropTypes.string,
  imageIsRound: PropTypes.bool,
  isActive: PropTypes.bool,
  isDanger: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSmall: PropTypes.bool,
  text: PropTypes.string.isRequired
};
DropdownLinkItem.displayName = 'DropdownLinkItem';

var styles$1 = {"modal":"storyliner-r2UYAXRn","modalIsActive":"storyliner-9Qr3fRrp","fade-in":"storyliner-mcg4g6NE","close":"storyliner-1S-FV-lk","contentContainer":"storyliner-5-ruoIAh","title":"storyliner-Imo0G92v","content":"storyliner-kLnqQ6GA","action":"storyliner-QIM-hAPj"};

/* eslint-disable @typescript-eslint/no-explicit-any */

var Modal = function Modal(_ref) {
  var cancelFunc = _ref.cancelFunc,
      cancelText = _ref.cancelText,
      children = _ref.children,
      closeFunc = _ref.closeFunc,
      closeModal = _ref.closeModal,
      closeText = _ref.closeText,
      confirmFunc = _ref.confirmFunc,
      confirmText = _ref.confirmText,
      confirmationLoading = _ref.confirmationLoading,
      customClasses = _ref.customClasses,
      isActive = _ref.isActive,
      locale = _ref.locale,
      title = _ref.title;
  // init styles
  var modalStyles = React.useMemo(function () {
    var _cn;

    return cn(styles$1['modal'], (_cn = {}, _cn[styles$1['modalIsActive']] = isActive, _cn));
  }, [isActive]);
  var modalContentStyles = React.useMemo(function () {
    return cn(styles$1['contentContainer'], customClasses);
  }, [customClasses]); // init vars

  var closeButtonText = React.useMemo(function () {
    if (closeText) {
      return closeText;
    }

    if (locale === 'de') {
      return 'Schließen';
    }

    return 'Close';
  }, [closeText, locale]);
  var confirmButtonText = React.useMemo(function () {
    if (confirmText) {
      return confirmText;
    }

    if (locale === 'de') {
      return 'Bestätigen';
    }

    return 'Confirm';
  }, [confirmText, locale]);
  var cancelButtonText = React.useMemo(function () {
    if (cancelText) {
      return cancelText;
    }

    if (locale === 'de') {
      return 'Abbrechen';
    }

    return 'Cancel';
  }, [cancelText, locale]);
  return React.createElement("div", {
    className: modalStyles,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    onKeyPress: function onKeyPress(event) {
      return event.stopPropagation();
    },
    role: "button",
    tabIndex: -1
  }, React.createElement("div", {
    className: modalContentStyles
  }, React.createElement("div", {
    className: styles$1['close']
  }, React.createElement(Button, {
    color: "dark",
    icon: "ri-close-line",
    isRound: true,
    onClick: closeModal
  })), title && React.createElement("div", {
    className: styles$1['title']
  }, title), React.createElement("div", {
    className: styles$1['content']
  }, children), (closeFunc || confirmFunc || cancelFunc) && React.createElement("div", {
    className: styles$1['action']
  }, closeFunc && React.createElement(Button, {
    color: "dark",
    onClick: closeFunc,
    text: closeButtonText
  }), confirmFunc && React.createElement(Button, {
    color: "dark",
    isLoading: confirmationLoading,
    onClick: confirmFunc,
    text: confirmButtonText
  }), cancelFunc && React.createElement(Button, {
    color: "ultraLight",
    onClick: cancelFunc,
    text: cancelButtonText
  }))));
};

Modal.defaultProps = {
  cancelFunc: undefined,
  cancelText: undefined,
  closeFunc: undefined,
  closeText: undefined,
  confirmFunc: undefined,
  confirmText: undefined,
  confirmationLoading: false,
  customClasses: undefined,
  title: undefined
};
Modal.propTypes = {
  cancelFunc: PropTypes.func,
  cancelText: PropTypes.string,
  children: PropTypes.node.isRequired,
  closeFunc: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
  closeText: PropTypes.string,
  confirmFunc: PropTypes.func,
  confirmText: PropTypes.string,
  confirmationLoading: PropTypes.bool,
  customClasses: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  locale: PropTypes.oneOf( /*#__PURE__*/Object.values(LocaleEnum)).isRequired,
  title: PropTypes.string
};
Modal.displayName = 'Modal';

var classNames = {"container":"storyliner-QM4Gc-RV","containerIsActive":"storyliner-7PT6HcCe","fade-in":"storyliner-dn8eydJH","content":"storyliner-tRvoNs5h"};

/* eslint-disable @typescript-eslint/ban-ts-comment */

var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children,
      closeModal = _ref.closeModal,
      isActive = _ref.isActive;
  // init func
  var onKeyPress = React.useCallback(function (event) {
    if (event.key === 'Enter' || event.key === 'Space') {
      event.preventDefault();
      closeModal();
    }
  }, [closeModal]);
  React.useEffect(function () {
    if (isActive) {
      // hide scrollbar
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    } else {
      // remove overflow style
      document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }
  }, [isActive]); // init styles

  var containerStyles = React.useMemo(function () {
    var _cn;

    return cn(classNames['container'], (_cn = {}, _cn[classNames['containerIsActive']] = isActive, _cn));
  }, [isActive]); // render

  return React.createElement("div", {
    className: containerStyles,
    onClick: closeModal,
    onKeyPress: onKeyPress,
    role: "button",
    tabIndex: 0
  }, React.createElement("div", {
    className: classNames['content']
  }, children));
};

ModalContainer.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired
};
ModalContainer.displayName = 'ModalContainer';

/* eslint-disable @typescript-eslint/no-explicit-any */

var ConfirmModal = function ConfirmModal(_ref) {
  var cancelFunc = _ref.cancelFunc,
      confirmFunc = _ref.confirmFunc,
      isActive = _ref.isActive,
      locale = _ref.locale,
      modalText = _ref.modalText,
      modalTitle = _ref.modalTitle;
  return React.createElement(ModalContainer, {
    isActive: isActive,
    closeModal: cancelFunc
  }, React.createElement(Modal, {
    cancelFunc: cancelFunc,
    closeModal: cancelFunc,
    confirmFunc: confirmFunc,
    isActive: isActive,
    locale: locale,
    title: modalTitle
  }, React.createElement(Text, null, modalText)));
};

ConfirmModal.propTypes = {
  cancelFunc: PropTypes.func.isRequired,
  confirmFunc: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  locale: PropTypes.oneOf( /*#__PURE__*/Object.values(LocaleEnum)).isRequired,
  modalText: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired
};
ConfirmModal.displayName = 'ConfirmModal';

var styles = {"close":"storyliner-IjU4EQfM","content":"storyliner--yKEUph-","contentContainer":"storyliner-ftRF00u7","canvas":"storyliner-12-9Rh4K","canvasIsActive":"storyliner--wjK66tH","fade-in":"storyliner-8JeSXFml"};

/* eslint-disable @typescript-eslint/ban-ts-comment */

var ModalCanvas = function ModalCanvas(_ref) {
  var children = _ref.children,
      closeModal = _ref.closeModal,
      isActive = _ref.isActive;
  // init func
  var onStopPropagation = React.useCallback(function (event) {
    event.stopPropagation();
  }, []); // init styles

  var modalCanvasStyles = React.useMemo(function () {
    var _cn;

    return cn(styles['canvas'], (_cn = {}, _cn[styles['canvasIsActive']] = isActive, _cn));
  }, [isActive]); // render

  return React.createElement("div", {
    className: modalCanvasStyles,
    onClick: onStopPropagation,
    onKeyPress: onStopPropagation,
    role: "presentation"
  }, React.createElement("div", {
    className: styles['close']
  }, React.createElement(Button, {
    color: "dark",
    icon: "ri-close-line",
    isRound: true,
    onClick: closeModal
  })), React.createElement("div", {
    className: styles['contentContainer']
  }, React.createElement("div", {
    className: styles['content']
  }, children)));
};

ModalCanvas.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired
};
ModalCanvas.displayName = 'ModalCanvas';

/* eslint-disable global-require */

// tailwind.preset.js
var tailwind_preset = {
  darkMode: 'class',
  plugins: [],
  theme: {
    boxShadow: {
      none: 'none',
      default: '0 0 3px rgba(91, 90, 90, 0.35)',
      hybrid: '0 0 6px rgba(69, 68, 68, 0.35)',
      hover: '0 0 12px rgba(47, 47, 46, 0.35)',
      'default-dark': '0 0 3px rgba(91, 91, 91, 0.5)',
      'hybrid-dark': '0 0 6px rgba(139, 139, 138, 0.5)',
      'hover-dark': '0 0 12px rgba(156, 156, 155, 0.5)'
    },
    colors: {
      current: 'currentColor',
      transparent: 'transparent',
      black: '#2F2F2E',
      gray: {
        zero: '#151515',
        one: '#5B5A5A',
        two: '#8B8B8A',
        three: '#BFBEBD',
        four: '#DBDAD9',
        five: '#F5F4F3'
      },
      white: '#ffffff',
      primary: '#008dd3',
      'primary-dark': '#A93D73',
      secondary: '#9ADDFF',
      'secondary-dark': '#CD6A73',
      success: '#2B8C83',
      'success-dark': '#1ECF9F',
      warning: '#F9F871',
      'warning-dark': '#F6DE55',
      error: '#C4515B',
      'error-dark': '#DC743D',
      overlay: 'rgba(47, 47, 46, 0.7)',
      'overlay-dark': 'rgba(245, 244, 243, 0.7)',
      tertiary: {
        one: '#2B8C83',
        two: '#1ECF9F',
        three: '#F9F871',
        four: '#F6DE55',
        five: '#FCF6D4',
        six: '#F5AA84',
        seven: '#DC743D',
        eight: '#AC4430',
        nine: '#C4515B',
        ten: '#cd6a73',
        eleven: '#cb709d',
        twelve: '#be4a84',
        thirteen: '#5e2240',
        fourteen: '#006BA0',
        fifteen: '#008dd3',
        sixteen: '#9ADDFF',
        seventeen: '#E5F6FF'
      },
      gradient: {
        white100: 'rgba(255, 255, 255, 1)',
        white75: 'rgba(255, 255, 255, 0.75)',
        white0: 'rgba(255, 255, 255, 0)',
        black100: 'rgba(21, 21, 21, 1)',
        black75: 'rgba(21, 21, 21, 0.75)',
        black0: 'rgba(21, 21, 21, 0)'
      }
    },
    extend: {
      animation: {
        'scale-out': 'scale-out 1000ms infinite ease-in-out',
        'fade-in': 'fade-in 200ms ease 1 both',
        'fade-in-up': 'fade-in-up 200ms ease-out 1 both'
      },
      keyframes: {
        'fade-in': {
          '0%': {
            opacity: '0'
          },
          '100%': {
            opacity: '1'
          }
        },
        'fade-in-up': {
          '0%': {
            opacity: '0',
            transform: 'translateY(6px)'
          },
          '100%': {
            opacity: '1',
            transform: 'translateY(0)'
          }
        },
        'scale-out': {
          '0%': {
            transform: 'scale(0)'
          },
          '100%': {
            transform: 'scale(1.0)',
            opacity: 0
          }
        }
      }
    },
    fontFamily: {
      default: 'Source Sans Pro, sans-serif',
      monospace: 'Source Code Pro, monospace',
      headlines: 'Poppins, sans-serif',
      buttons: 'Poppins, sans-serif'
    }
  }
};

var tailwind_preset$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': tailwind_preset
}, [tailwind_preset]);

export { Autosuggest, Button, ButtonColorEnum, ButtonSizeEnum, ButtonTypeEnum, Card, Checkbox, CheckboxOrientationEnum, ConfirmModal, ContextMenu, Dropdown, DropdownDivider, DropdownHeader, DropdownItem, DropdownLinkItem, DropdownMenu, DropdownPlacementEnum, Dropzone, Form, Heading, HeadingAlignmentEnum, HeadingTagEnum, InfiniteGrid, InfoBox, Input, LanguageSwitcher, LinkButton, LocaleEnum, Logo, LogoLettering, LogoSymbol, MasonryGrid, Modal, ModalCanvas, ModalContainer, RemixIcon, Select, SkeletonBlock, Spacer, SpacerBackgroundColorEnum, Spinner, StorylinerPortal, Switch, SwitchAlignmentEnum, SwitchDirectionEnum, Table, TableCol, TableHead, TableRow, TagColorEnum, Tags, Text, TextAlignmentEnum, TextSizeEnum, Textarea, Tooltip, TooltipPlacementEnum, tailwind_preset$1 as storylinerPreset };
//# sourceMappingURL=design.esm.js.map
